import React, { useState, useEffect, useRef } from "react";
import { firebase, authe } from "../Firebase/config";

import "./App.css";
import axios from "axios";
import {
    getAuth,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendEmailVerification,
    onAuthStateChanged,
    deleteUser,
} from "@firebase/auth";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
    onSnapshot,
    orderBy,
    limit,
    collection,
    addDoc,
    query,
    where,
    getDocs,
    deleteDoc,
    doc,
    setDoc,
    getDoc,
    updateDoc,
    arrayUnion,
    getCountFromServer,
} from "@firebase/firestore";
import {
    Link,
    Route,
    Routes,
    useParams,
    useNavigate,
    useLocation,
    redirect,
} from "react-router-dom";
import "./SignIn2.css";
import NavBar from "./Navbar";

const SignIn = ({ route, navigation }) => {
    // Modal state for backend response
    const [isBackendModalOpen, setIsBackendModalOpen] = useState(false);
    const [backendModalTitle, setBackendModalTitle] = useState("");
    const [backendModalMessage, setBackendModalMessage] = useState("");
    const [backendModalDetails, setBackendModalDetails] = useState(null);

    const { only2studentid, studentid, classid, language, role, id } = useParams();
    const navigate = useNavigate();
    const [donotshow, setDonotshow] = useState();
    const sections = [
        { Name: "Active Passes", key: 1 },
        { Name: "Search By Name", key: 2 },
        { Name: "Search By Date", key: 3 },
    ];
    const [selectedclass, setSelectedclass] = useState();
    const [activename, setActivename] = useState("Active Passes");
    const [id2, setId] = useState();
    const [school2, setSchool] = useState();
    const [state2, setState] = useState();
    const [town2, setTown] = useState();
    const [role2, setRole] = useState();
    const [firstname2, setFirstname] = useState();
    const [lastname2, setLastname] = useState();
    const [phone2, setPhone2] = useState();
    const [teacheriscalled2, setTeacheriscalled] = useState();
    const [email2, setEmail] = useState();
    const [showspinner, setShowspinner] = useState();

    const [errorMessage, setErrorMessage] = useState("");
    const [emaillocal, setEmaillocal] = useState("");
    const [passwordlocal, setPasswordlocal] = useState("");

    const [previousEmails, setPreviousEmails] = useState([]);
    const [showEmailDropdown, setShowEmailDropdown] = useState(false);
    const [filteredEmails, setFilteredEmails] = useState([]);

    const [someoneisloggedin, setsomeoneisloggedin] = useState();
    const [passwordShown, setPasswordShown] = useState(true);
    const [oneway, setOneway] = useState();

    const [nothingfound, setNothingfound] = useState(false);

    const [personaldata, setPersonaldata] = useState();
    const [schoolid, setSchoolid] = useState();

    const [newdescriptiontobesaved, setNewdescriptiontobesaved] = useState("");
    const [localdescription, setLocaldescription] = useState("");
    const [includeGoogleAssignmentAttachment, setIncludeGoogleAssignmentAttachment] = useState(false);
    const [linkModalTarget, setLinkModalTarget] = useState("local");
    const [linkFrontText, setLinkFrontText] = useState("");
    const [linkHref, setLinkHref] = useState("");
    const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
    const [newwidth, setNewwidth] = useState(50);

    const [isOpen8, setIsOpen8] = useState(false);
    const [isOpen9, setIsOpen9] = useState(false);
    const [isOpen10, setIsOpen10] = useState(false);
    const [isOpen11, setIsOpen11] = useState(false);
    const [isOpen12, setIsOpen12] = useState(false);
    const [isOpen13, setIsOpen13] = useState(false);

    const [isOpen17, setIsOpen17] = useState(false);

    const [sendStatus, setSendStatus] = useState("idle"); // "idle" | "sending" | "sent" | "error"
    const [sendError, setSendError] = useState("");

    const [thesearethemessages2, setThesearethemessages2] = useState([]);
    const [thesearethemessages, setThesearethemessages] = useState([]);

    const [showPreparedMessages, setShowPreparedMessages] = useState(false);

    const [awaitingConfirmSend, setAwaitingConfirmSend] = useState(false);
    const [localclassid, setLocalclassid] = useState("");
    const [localteacherid, setLocalteacherid] = useState("");
    const [locallinklevel, setLocallinklevel] = useState(0);
    const [valueToSendOrNotSentEmails, setValueToSendOrNotSentEmails] = useState("0");
    const [valueToSendOrNotSentEmailsHigh, setValueToSendOrNotSentEmailsHigh] = useState("100");

    const [localteachername, setLocalteachername] = useState("");
    const [locaschoolname, setLocalschoolname] = useState("");
    const [localcoursename, setLocalcoursename] = useState("");

    const [isLinkLevelModalOpen, setIsLinkLevelModalOpen] = useState(false);
    const [tempLinkLevel, setTempLinkLevel] = useState(locallinklevel);
    // ...existing code...
    const [studentLinks, setStudentLinks] = useState({});

    const [isOpen24, setIsOpen24] = useState(false);

    const [students, setStudents] = useState([]);

    const [towhom, setTowhom] = useState("");
    const [whentohwhom, setWhentohwhom] = useState(0);

    const [notifications, setNotifications] = useState([]);
    const [notificationsLoading, setNotificationsLoading] = useState(false);
    const [notificationsError, setNotificationsError] = useState("");

    const [emailReportModalVisible, setEmailReportModalVisible] = useState(false);
    const [emailSendStatus, setEmailSendStatus] = useState("unknown");
    const [emailSenderAccount, setEmailSenderAccount] = useState("");
    const [emailRequestedCount, setEmailRequestedCount] = useState(0);
    const [emailSentCountTarget, setEmailSentCountTarget] = useState(0);
    const [emailSentCountAnimated, setEmailSentCountAnimated] = useState(0);
    const [emailFailedCount, setEmailFailedCount] = useState(0);
    const [emailSentFolderConfirmedCount, setEmailSentFolderConfirmedCount] = useState(0);
    const [emailSentFolderUnverifiedCount, setEmailSentFolderUnverifiedCount] = useState(0);
    const [emailFailedRecipients, setEmailFailedRecipients] = useState([]);
    const [emailModalMessage, setEmailModalMessage] = useState("");
    const [emailCountsNotReported, setEmailCountsNotReported] = useState({
        requested: false,
        sent: false,
        failed: false,
        sentFolderConfirmed: false,
        sentFolderUnverified: false,
    });
    const [isNotificationsModalOpen, setIsNotificationsModalOpen] = useState(false);
    const [selectedNotificationId, setSelectedNotificationId] = useState("");

    const [attachmentchoice, setAttachmentchoice] = useState("All attachments");

    const isAllAttachmentChoice = attachmentchoice === "All attachments";
    const workHeading = isAllAttachmentChoice ? "All Work" : "Student Work";

    const ATTACHMENT_CHOICES = [
        "All attachments",
        "googledoc",
        "googleslides",
        "googledrawings",
        "googleforms",
        "googlesheets",
        "youtubevideo",
        "googlesites",
        "googlevids",
        "mp4",
    ];


    const ATTACHMENT_CHOICE_UI = {
        "All attachments": {
            label: "All attachments",
            image: null,
        },
        googledoc: {
            label: "Google Docs",
            image: require("./assets/GoogleDocsExample.png"),
        },
        googleslides: {
            label: "Google Slides",
            image: require("./assets/SlidesExample.png"),
        },
        googledrawings: {
            label: "Google Drawings",
            image: require("./assets/GoogleDrawingsexample.png"),
        },
        googleforms: {
            label: "Google Forms",
            image: require("./assets/GoogleFormsExample.png"),
        },
        googlesheets: {
            label: "Google Sheets",
            image: require("./assets/SheetsExample.png"),
        },
        youtubevideo: {
            label: "YouTube Video",
            image: require("./assets/YouTubeVideoExample.png"),
        },
        googlesites: {
            label: "Google Sites",
            image: require("./assets/GoogleSitesExample.png"),
        },
        googlevids: {
            label: "Google Vids",
            image: require("./assets/GoogleVidsExample.png"),
        },
        mp4: {
            label: "MP4",
            image: require("./assets/mp4example.png"),
        },
    };


    const selectedAttachmentUi =
        ATTACHMENT_CHOICE_UI[attachmentchoice] || ATTACHMENT_CHOICE_UI["All attachments"];

    const toSafeNumber = (value, fallback = 0) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
    };

    const normalizeValueToSendOrNotSentEmails = (value, fallback = 0) => {
        const digitsOnly = String(value ?? "")
            .replace(/\D/g, "")
            .slice(0, 3);

        if (digitsOnly.length === 0) {
            return String(fallback);
        }

        const normalizedValue = Math.min(100, Math.max(0, toSafeNumber(digitsOnly, fallback)));
        return String(normalizedValue);
    };

    const normalizeEmailScoreRange = (lowValue, highValue) => {
        const normalizedLow = toSafeNumber(
            normalizeValueToSendOrNotSentEmails(lowValue, 0),
            0
        );
        const normalizedHigh = toSafeNumber(
            normalizeValueToSendOrNotSentEmails(highValue, 100),
            100
        );

        return {
            low: Math.min(normalizedLow, normalizedHigh),
            high: Math.max(normalizedLow, normalizedHigh),
        };
    };

    const emailScoreThresholdClassId = String(localclassid || selectedclass?.id || classid || "").trim();

    const saveEmailScoreThresholdSettings = async (updates = {}) => {
        if (!emailScoreThresholdClassId) {
            return;
        }

        try {
            await updateDoc(doc(firebase, "classesbeingtaught", emailScoreThresholdClassId), updates);
        } catch (error) {
            console.error("Failed to save email score threshold settings:", error);
        }
    };

    const commitValueToSendOrNotSentEmails = () => {
        const currentHighValue = toSafeNumber(
            normalizeValueToSendOrNotSentEmails(valueToSendOrNotSentEmailsHigh, 100),
            100
        );
        const normalizedValue = Math.min(
            toSafeNumber(
                normalizeValueToSendOrNotSentEmails(valueToSendOrNotSentEmails, 0),
                0
            ),
            currentHighValue
        );

        setValueToSendOrNotSentEmails(String(normalizedValue));
        setValueToSendOrNotSentEmailsHigh(String(currentHighValue));
    };

    const commitValueToSendOrNotSentEmailsHigh = () => {
        const currentLowValue = toSafeNumber(
            normalizeValueToSendOrNotSentEmails(valueToSendOrNotSentEmails, 0),
            0
        );
        const normalizedValue = Math.max(
            toSafeNumber(
                normalizeValueToSendOrNotSentEmails(valueToSendOrNotSentEmailsHigh, 100),
                100
            ),
            currentLowValue
        );

        setValueToSendOrNotSentEmails(String(currentLowValue));
        setValueToSendOrNotSentEmailsHigh(String(normalizedValue));
    };

    const normalizeStudentForPreviewFilter = (rawStudent) => {
        if (!rawStudent) {
            return {};
        }

        if (typeof rawStudent === "string") {
            const trimmed = rawStudent.trim();

            if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
                try {
                    return JSON.parse(rawStudent);
                } catch (error) {
                    return {};
                }
            }
        }

        return rawStudent;
    };

    const getSelectedAssignmentGradeMaps = () => {
        const gradesMap = {};
        const gradesMapByName = {};
        const gradesMapById = {};

        try {
            const rawGrades = localStorage.getItem("fetchGradesOfSelectedAssignment");

            if (!rawGrades) {
                return { gradesMap, gradesMapByName, gradesMapById };
            }

            const parsedGrades = JSON.parse(rawGrades);

            if (!Array.isArray(parsedGrades?.studentsWithGrades)) {
                return { gradesMap, gradesMapByName, gradesMapById };
            }

            parsedGrades.studentsWithGrades.forEach((entry) => {
                const numericGrade = Number(entry?.grade);

                if (!Number.isFinite(numericGrade)) {
                    return;
                }

                const email = (entry?.email || "").trim().toLowerCase();
                const fullName = (entry?.name || "").trim().toLowerCase();
                const googleStudentId = (entry?.id || "").toString().trim();

                if (email) {
                    gradesMap[email] = numericGrade;
                }

                if (fullName) {
                    gradesMapByName[fullName] = numericGrade;
                }

                if (googleStudentId) {
                    gradesMapById[googleStudentId] = numericGrade;
                }
            });
        } catch (error) {
            console.error("Failed to parse selected assignment grades for preview filter:", error);
        }

        return { gradesMap, gradesMapByName, gradesMapById };
    };

    const getPreparedMessageNumericGrade = (message) => {
        const { gradesMap, gradesMapByName, gradesMapById } = getSelectedAssignmentGradeMaps();

        const googleStudentId = (message?.googleid || "").toString().trim();
        if (googleStudentId && typeof gradesMapById[googleStudentId] !== "undefined") {
            return gradesMapById[googleStudentId];
        }

        const studentRecord = (Array.isArray(students) ? students : [])
            .map(normalizeStudentForPreviewFilter)
            .find((student) => {
                const firebaseStudentId = (student?.firebasestudentid || student?.id || "").toString().trim();
                const studentGoogleId = (student?.studentId || student?.studentid || student?.googleclassroomid || "").toString().trim();

                return (
                    (message?.studentId && firebaseStudentId === String(message.studentId).trim()) ||
                    (googleStudentId && studentGoogleId === googleStudentId)
                );
            });

        if (!studentRecord) {
            return null;
        }

        const studentEmail = (studentRecord?.email || "").trim().toLowerCase();
        if (studentEmail && typeof gradesMap[studentEmail] !== "undefined") {
            return gradesMap[studentEmail];
        }

        const studentGoogleId = (studentRecord?.studentId || studentRecord?.studentid || studentRecord?.googleclassroomid || "").toString().trim();
        if (studentGoogleId && typeof gradesMapById[studentGoogleId] !== "undefined") {
            return gradesMapById[studentGoogleId];
        }

        const fullName = `${studentRecord?.firstName || ""} ${studentRecord?.lastName || ""}`.trim().toLowerCase();
        if (fullName && typeof gradesMapByName[fullName] !== "undefined") {
            return gradesMapByName[fullName];
        }

        return null;
    };

    const applyScoreFilterToParentPreview = () => {
        const sourceMessages = Array.isArray(thesearethemessages2) ? thesearethemessages2 : [];
        const { low, high } = normalizeEmailScoreRange(
            valueToSendOrNotSentEmails,
            valueToSendOrNotSentEmailsHigh
        );

        setValueToSendOrNotSentEmails(String(low));
        setValueToSendOrNotSentEmailsHigh(String(high));
        saveEmailScoreThresholdSettings({
            valuetosendornotsentemails: low,
            valuetosendornotsentemailshigh: high,
        });

        const filteredMessages = sourceMessages.filter((message) => {
            const numericGrade = getPreparedMessageNumericGrade(message);

            return Number.isFinite(numericGrade) && numericGrade >= low && numericGrade <= high;
        });

        setThesearethemessages(filteredMessages);
        console.log("[Apply filter] Parent preview updated", {
            low,
            high,
            originalCount: sourceMessages.length,
            filteredCount: filteredMessages.length,
        });
    };

    function getNextAttachmentChoice(currentValue) {
        const idx = ATTACHMENT_CHOICES.indexOf(currentValue);
        if (idx === -1 || idx === ATTACHMENT_CHOICES.length - 1) {
            return ATTACHMENT_CHOICES[0];
        }
        return ATTACHMENT_CHOICES[idx + 1];
    }

    async function changeattachmentchoice() {
        const nextValue = getNextAttachmentChoice(attachmentchoice);

        setAttachmentchoice(nextValue);

        const targetClassId = localclassid || classid;
        if (!targetClassId) return;

        updateDoc(doc(firebase, "classesbeingtaught", targetClassId), {
            Attachmentchoice: nextValue,
        }).catch((error) => {
            console.log(error);
            alert(error);
        });
    }




    const getNotificationDisplayText = (notification) => {
        if (!notification || typeof notification !== "object") {
            return "";
        }

        let text = (
            notification.note ||
            notification.message ||
            notification.notification ||
            notification.description ||
            notification.text ||
            notification.body ||
            ""
        ).toString().trim();

        text = resolveAssignmentNameTokens(text);

        return text;
    };

    const handleLoadNotifications = () => {
        const count = Array.isArray(notifications) ? notifications.length : 0;

        console.log("[Notifications] Load button clicked.", {
            towhom,
            count,
            notifications,
        });

        if (!Array.isArray(notifications) || notifications.length === 0) {
            console.log("[Notifications] No notifications available. Modal will not open.");
            return;
        }

        setSelectedNotificationId("");
        setIsNotificationsModalOpen(true);

        console.log("[Notifications] Modal opened. Waiting for user to select a notification.");
    };

    const closeNotificationsModal = () => {
        console.log("[Notifications] Closing modal.");
        setIsNotificationsModalOpen(false);
        setSelectedNotificationId("");
    };

    const handleSelectNotification = () => {
        if (!selectedNotificationId) {
            console.log("[Notifications] No notification selected. Nothing loaded.");
            return;
        }

        const selectedNotification = notifications.find(
            (item) => item?.id === selectedNotificationId
        );

        if (!selectedNotification) {
            console.log("[Notifications] Selected notification could not be found.", {
                selectedNotificationId,
            });
            return;
        }

        const selectedText = getNotificationDisplayText(selectedNotification);

        if (!selectedText) {
            console.log("[Notifications] Selected notification has no usable text field.", selectedNotification);
            return;
        }

        setLocaldescription(selectedText);
        setIsNotificationsModalOpen(false);
        setSelectedNotificationId("");

        console.log("[Notifications] Selected notification loaded into localdescription.", {
            docId: selectedNotification.id || null,
            selectedText,
        });
    };

    const renderNotificationsModal = () => {
        if (!isNotificationsModalOpen) {
            return null;
        }

        const selectedNotification = notifications.find(
            (item) => item?.id === selectedNotificationId
        );

        return (
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(0,0,0,0.65)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 99999,
                    padding: 16,
                }}
                onClick={closeNotificationsModal}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        width: "min(760px, 96vw)",
                        maxHeight: "85vh",
                        overflow: "hidden",
                        background: "#000",
                        color: "#fff",
                        borderRadius: 18,
                        padding: 24,
                        boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
                        border: "2px solid #e43522",
                        display: "flex",
                        flexDirection: "column",
                        gap: 16,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 12,
                        }}
                    >
                        <h2 style={{ margin: 0, fontSize: 28, marginLeft: "auto", marginRight: "auto" }}>Load Notification</h2>

                    </div>

                    {notificationsLoading ? (
                        <div
                            style={{
                                background: "#1a1a1a",
                                borderRadius: 12,
                                padding: 16,
                                color: "#d7d7d7",
                            }}
                        >
                            Loading notifications...
                        </div>
                    ) : notificationsError ? (
                        <div
                            style={{
                                background: "#2a1515",
                                border: "1px solid rgba(255,107,107,0.35)",
                                borderRadius: 12,
                                padding: 16,
                                color: "#ffb3b3",
                            }}
                        >
                            {notificationsError}
                        </div>
                    ) : !Array.isArray(notifications) || notifications.length === 0 ? (
                        <div
                            style={{
                                background: "#000",
                                borderRadius: 12,
                                padding: 16,
                                color: "#d7d7d7",
                            }}
                        >
                            No notifications were found.
                        </div>
                    ) : (
                        <>
                            <style>
                                {`
            .notifications-scroll-area {
                scrollbar-gutter: stable;
            }

          .notifications-scroll-area::-webkit-scrollbar {
    width: 28px;
}

.notifications-scroll-area::-webkit-scrollbar-track {
    background: #1a1a1a;
    border-radius: 12px;
}

.notifications-scroll-area::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 12px;
    border: 1px solid #1a1a1a;
    min-height: 48px;
}

.notifications-scroll-area::-webkit-scrollbar-thumb:hover {
    background: #aaa;
}
        `}
                            </style>

                            <div
                                className="notifications-scroll-area"
                                style={{
                                    background: "#222",
                                    overflowY: "auto",
                                    overflowX: "hidden",
                                    maxHeight: "50vh",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 12,
                                    paddingRight: 14,
                                    scrollbarWidth: "auto",
                                    scrollbarColor: "#666 #1a1a1a",
                                }}
                            >
                                {notifications.map((item, index) => {
                                    const text = getNotificationDisplayText(item);
                                    const isSelected = selectedNotificationId === item.id;

                                    return (
                                        <button
                                            key={item.id || index}
                                            type="button"
                                            onClick={() => {
                                                setSelectedNotificationId(item.id);
                                                console.log("[Notifications] Notification selected.", {
                                                    docId: item.id || null,
                                                    text,
                                                });
                                            }}
                                            className={isSelected ? "notification-item notification-item-selected" : "notification-item"}
                                        >
                                            <div
                                                style={{
                                                    whiteSpace: "pre-wrap",
                                                    lineHeight: 1.5,
                                                    fontSize: 16,
                                                }}
                                            >
                                                {text || "This notification does not contain a note."}
                                            </div>
                                        </button>
                                    );
                                })}
                            </div>
                        </>
                    )}


                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 10,
                        }}
                    >
                        <button
                            type="button"
                            onClick={closeNotificationsModal}
                            style={{
                                padding: "10px 16px",
                                borderRadius: 10,
                                border: "none",
                                background: "#444",
                                color: "#fff",
                                fontSize: 16,
                                cursor: "pointer",
                            }}
                        >
                            Close
                        </button>

                        <button
                            type="button"
                            onClick={handleSelectNotification}
                            disabled={!selectedNotificationId}
                            style={{
                                padding: "10px 16px",
                                borderRadius: 10,
                                border: "none",
                                background: selectedNotificationId ? "#0a84ff" : "#2d4f73",
                                color: "#fff",
                                fontSize: 16,
                                cursor: selectedNotificationId ? "pointer" : "default",
                                opacity: selectedNotificationId ? 1 : 0.7,
                            }}
                        >
                            {selectedNotificationId ? "Select" : "Select"}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // On mount, get these values from localStorage
    useEffect(() => {
        const storedTowhom = localStorage.getItem("parentorstudentnote") || "";
        const storedWhen = parseInt(localStorage.getItem("parentorstudentnotetimesent"), 10) || 0;

        if (storedWhen > (Date.now() - 5000)) {

            if (storedTowhom == "students") {
                setTowhom("Students");
            } else if (storedTowhom == "parents") {
                setTowhom("Parents");
            } else {
                setTowhom("Both");
            }
        }
    }, []);

    useEffect(() => {
        if (!towhom || !id) {
            setNotifications([]);
            return;
        }

        const fetchNotifications = async () => {
            setNotificationsLoading(true);
            setNotificationsError("");

            try {
                if (towhom === "Parents") {
                    const parentsQuery = query(
                        collection(firebase, "Notifications"),
                        where("notificationsfor", "==", "parents"),
                        where("teacherid", "==", id)
                    );

                    const querySnapshot = await getDocs(parentsQuery);

                    const parentDocs = querySnapshot.docs.map((docSnap) => ({
                        id: docSnap.id,
                        ...docSnap.data(),
                    }));

                    setNotifications(parentDocs);
                    console.log("Fetched parent notifications:", parentDocs);
                    return;
                }

                if (towhom === "Students") {
                    const studentsQuery = query(
                        collection(firebase, "Notifications"),
                        where("notificationsfor", "==", "students"),
                        where("teacherid", "==", id)
                    );

                    const querySnapshot = await getDocs(studentsQuery);

                    const studentDocs = querySnapshot.docs.map((docSnap) => ({
                        id: docSnap.id,
                        ...docSnap.data(),
                    }));

                    setNotifications(studentDocs);
                    console.log("Fetched student notifications:", studentDocs);
                    return;
                }

                if (towhom === "Both") {
                    const bothQuery = query(
                        collection(firebase, "Notifications"),
                        where("notificationsfor", "==", "both"),
                        where("teacherid", "==", id)
                    );

                    const querySnapshot = await getDocs(bothQuery);

                    const bothDocs = querySnapshot.docs.map((docSnap) => ({
                        id: docSnap.id,
                        ...docSnap.data(),
                    }));

                    setNotifications(bothDocs);
                    console.log("Fetched both notifications:", bothDocs);
                    return;
                }

                setNotifications([]);
            } catch (e) {
                console.error("Error fetching notifications:", e);
                setNotifications([]);
                setNotificationsError(e?.message || "Failed to fetch notifications.");
            } finally {
                setNotificationsLoading(false);
            }
        };

        fetchNotifications();
    }, [towhom, id]);





    // Load "infoforsending" from localStorage when the component mounts







    // -----------------------------------------------------------------------------
    // Gmail / Google API frontend integration (requires CLIENT_ID and API_KEY)
    // Place your OAuth client id and API key here or load from env at build time.
    // For production use, you should route sending through a backend to keep
    // credentials secure. This frontend-only flow uses gapi + OAuth popup.
    // -----------------------------------------------------------------------------
    const [gapiLoaded, setGapiLoaded] = useState(false);
    const [googleSignedIn, setGoogleSignedIn] = useState(false);
    const [parentlanguagecodes, setParentLanguageCodes] = useState([]);
    const gapiRef = React.useRef(null);

    // NEW: GIS token client ref to replace gapi.auth2 usage
    const tokenClientRef = React.useRef(null);

    // replace with your Google OAuth Client ID & API key
    const GOOGLE_CLIENT_ID = "<YOUR_GOOGLE_OAUTH_CLIENT_ID>";
    const GOOGLE_API_KEY = "<YOUR_GOOGLE_API_KEY>";
    const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest"];
    const SCOPES = "https://www.googleapis.com/auth/gmail.send";

    // Get route params - in web version this would be from URL or context
    const donewithquickpass = route?.params?.donewithquickpass;


    const newidforadmin = "/role/Admin/mainmenupage/id/" + id2;
    const newidforteacher = "/role/Teacher/mainmenu/id/" + id2;
    const newidforstudent1 = "/role/Student/Mainmenustudents/id/" + id2;
    const adminaddress = "/role/Admin/mainmenupage/id/" + id2;


    const location = useLocation();

    // ...existing code...
    const searchParams = new URLSearchParams(location.search);
    const hashParams = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const assignmentName = searchParams.get("assignmentName") || "";
    const assignmentIdFromUrl = searchParams.get("assignmentId") || hashParams.get("assignmentId") || "";
    // ...existing code...


    const arrivedFromMainMenu = Boolean(location.state?.selectedclass || location.state?.temparray);
    // ...existing code...



    const incomingState = location?.state || {};
    const incomingSelectedClass = incomingState.selectedclass ?? null;
    const incomingTemparray = incomingState.temparray ?? null;
    const incomingSelectedAssignmentName = typeof incomingState.selectedAssignmentName === "string"
        ? incomingState.selectedAssignmentName.trim()
        : "";
    const incomingSelectedAssignmentId = incomingState?.selectedAssignmentId !== undefined && incomingState?.selectedAssignmentId !== null
        ? String(incomingState.selectedAssignmentId).trim()
        : (incomingState?.assignmentId !== undefined && incomingState?.assignmentId !== null
            ? String(incomingState.assignmentId).trim()
            : "");

    const maskEmailForLog = (email) => {
        if (!email || typeof email !== "string") return "";
        const [name, domain] = email.split("@");
        if (!domain) return "***";
        return `${(name || "").slice(0, 2)}***@${domain}`;
    };

    const logEmailFlow = (stage, data = {}) => {
        console.log(`[email-flow] ${stage}`, data);
    };

    const readStoredSelectedAssignment = () => {
        try {
            const raw = localStorage.getItem("fetchGradesOfSelectedAssignment");
            if (!raw) {
                return { assignmentId: "", assignmentName: "" };
            }

            const parsed = JSON.parse(raw);
            return {
                assignmentId: parsed?.assignmentId ? String(parsed.assignmentId).trim() : "",
                assignmentName: typeof parsed?.assignmentName === "string" ? parsed.assignmentName.trim() : "",
            };
        } catch (error) {
            console.error("[Assignment Sync] Failed to read selected assignment from localStorage:", error);
            return { assignmentId: "", assignmentName: "" };
        }
    };

    const getCurrentAssignmentSelection = () => {
        const storedSelection = readStoredSelectedAssignment();
        const explicitAssignmentName = incomingSelectedAssignmentName || assignmentName || "";
        const explicitAssignmentId = incomingSelectedAssignmentId || assignmentIdFromUrl || "";
        const courseId = localStorage.getItem("gclassroomid") || "";

        if (explicitAssignmentName && !explicitAssignmentId) {
            console.warn("[Assignment Sync] Visible assignment name has no live assignment id; refusing to fall back to stale localStorage assignmentId.", {
                explicitAssignmentName,
                storedAssignmentId: storedSelection.assignmentId || null,
                storedAssignmentName: storedSelection.assignmentName || null,
                locationSearch: location.search || "",
                locationHash: location.hash || "",
            });

            return {
                courseId,
                assignmentId: "",
                assignmentName: explicitAssignmentName,
                source: "explicitNameWithoutId",
            };
        }

        return {
            courseId,
            assignmentId: explicitAssignmentId || storedSelection.assignmentId || "",
            assignmentName: explicitAssignmentName || storedSelection.assignmentName || "",
            source: explicitAssignmentId
                ? (incomingSelectedAssignmentId ? "location.state" : "url")
                : (storedSelection.assignmentId ? "localStorage" : "none"),
        };
    };

    const getCurrentAssignmentName = () => {
        return getCurrentAssignmentSelection().assignmentName;
    };

    const resolveAssignmentNameTokens = (text) => {
        const normalizedText = typeof text === "string" ? text : "";

        if (!normalizedText.includes("{GClassroom Assignment Name}")) {
            return normalizedText;
        }

        return normalizedText.replaceAll("{GClassroom Assignment Name}", getCurrentAssignmentName());
    };

    // language: javascript
    // filepath: /Users/Matt/Desktop/fastclasspassforweb/frontend/src/Components/Messageforsending.js
    // ...existing code...

    // Fallback: fetch full student docs when Messageforsending is loaded directly (no MainMenu state)



    async function sendingemails3(studentsOverride, options = {}) {
        console.log("9HERE ARE THE MESSAGES [sendingemails3] studentsOverride received:", studentsOverride);

        const recipientMode = options.recipientMode || towhom;
        const globalSubject = makeEmailSubject();

        console.log("sendingemails3 invoked", {
            localdescription,
            parentlanguagecodes,
            studentsCount: students.length,
            locallinklevel,
            localclassid,
            localteacherid,
            recipientMode,
        });

        const apiKey = process.env.REACT_APP_GOOGLE_API_KEY || "";
        if (!apiKey) {
            console.warn("REACT_APP_GOOGLE_API_KEY not set — translations will be skipped/fallback.");
        }

        const originalTemplate = resolveAssignmentNameTokens((localdescription || "").trim());
        if (!originalTemplate) {
            alert("Message body is empty.");
            return [];
        }

        const langs =
            Array.isArray(parentlanguagecodes) && parentlanguagecodes.length > 0
                ? parentlanguagecodes
                : ["en"];

        console.log("sendingemails3: languages to process:", langs);

        const studentsToUse =
            Array.isArray(studentsOverride) && studentsOverride.length > 0
                ? studentsOverride
                : students;

        console.log("sendingemails3: using students source, count:", studentsToUse.length);

        const extractAndRemoveLinks = (text) => {
            const linkRegex = /\{Link\|[^|}]+\|[^}]+\}/g;
            const links = [];
            let match;

            while ((match = linkRegex.exec(text)) !== null) {
                links.push(match[0]);
            }

            const textWithoutLinks = text.replace(linkRegex, "{LINK_PLACEHOLDER}");
            return { textWithoutLinks, links };
        };

        const reinjectLinks = (text, links) => {
            let result = text;
            for (const link of links) {
                result = result.replace("{LINK_PLACEHOLDER}", link);
            }
            return result;
        };

        const { textWithoutLinks: templateWithoutLinks, links: extractedLinks } =
            extractAndRemoveLinks(originalTemplate);

        console.log("Extracted links:", extractedLinks);
        console.log("Template without links:", templateWithoutLinks);

        const safeParseKeyValueString = (str) => {
            const out = {};
            if (!str || typeof str !== "string") return out;

            const parts = str.split(/,(?=\s*[A-Za-z0-9_])/);
            for (const part of parts) {
                const idx = part.indexOf(":");
                if (idx === -1) continue;

                const key = part.slice(0, idx).trim().replace(/(^['"]|['"]$)/g, "");
                let val = part
                    .slice(idx + 1)
                    .trim()
                    .replace(/^[\(\[\{]\s*/, "")
                    .replace(/\s*[\)\]\}]$/, "")
                    .trim();

                if (!val) {
                    out[key] = val;
                    continue;
                }

                if (val.startsWith("[") || val.includes("','") || val.includes('","')) {
                    out[key] = val
                        .replace(/^\[|\]$/g, "")
                        .split(/[,;]+/)
                        .map((x) => x.replace(/['"\s]/g, "").trim())
                        .filter(Boolean);
                } else {
                    out[key] = val.replace(/^['"]|['"]$/g, "").trim();
                }
            }

            return out;
        };

        const normalizeStudent = (student) => {
            if (!student) return {};

            if (typeof student === "string") {
                const trimmed = student.trim();
                if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
                    try {
                        return JSON.parse(student);
                    } catch (e) { }
                } else {
                    const kv = safeParseKeyValueString(student);
                    kv.rawString = student;
                    return kv;
                }
            }

            return student;
        };

        const extractParentEmails = (student) => {
            if (!student) return [];

            const keys = [
                "parentemail",
                "parentEmail",
                "parentemails",
                "parent_emails",
                "guardianEmail",
                "guardian_email",
                "parentEmails",
                "parents",
                "contactEmail",
            ];

            for (const key of keys) {
                const value = student[key];
                if (typeof value === "undefined" || value === null) continue;

                if (Array.isArray(value)) {
                    return value.map((v) => (v || "").toString().trim()).filter(Boolean);
                }

                if (typeof value === "string") {
                    const parts = value.split(/[,;]+/).map((p) => p.trim()).filter(Boolean);
                    if (parts.length) return parts;
                }
            }

            if (student.data && typeof student.data === "object") return extractParentEmails(student.data);
            if (student.payload && typeof student.payload === "object") return extractParentEmails(student.payload);

            return [];
        };

        const buildStudentLinkLocal = (student, overrideLinkLevel, overrideLinksMap) => {
            if (!student || typeof student !== "object") return "";

            const studentId = (
                student.firebasestudentid ||
                student.studentId ||
                student.studentid ||
                student.id ||
                ""
            ).toString();

            const linksMap = overrideLinksMap || studentLinks;
            const linkLevelToUse =
                typeof overrideLinkLevel !== "undefined" ? overrideLinkLevel : locallinklevel;

            if (studentId && linksMap && typeof linksMap[studentId] !== "undefined") {
                return linksMap[studentId] || "";
            }

            const classId = (localclassid || "").toString();
            const teacherId = (localteacherid || id || "").toString();
            const lang = (
                student.parentlanguagecode ||
                student.parentLanguageCode ||
                "en"
            ).toString().trim() || "en";

            if (!studentId || !classId || !teacherId) return "";

            const host = "https://fastclasspass.web.app";
            if (linkLevelToUse === 1) {
                return `${host}/only2studentid/${encodeURIComponent(studentId)}/${encodeURIComponent(classId)}/id/${encodeURIComponent(teacherId)}/language/${encodeURIComponent(lang)}`;
            }
            if (linkLevelToUse === 2) {
                return `${host}/studentid/${encodeURIComponent(studentId)}/${encodeURIComponent(classId)}/id/${encodeURIComponent(teacherId)}/language/${encodeURIComponent(lang)}`;
            }

            return "";
        };

        let gradesMap = {};
        let gradesMapByName = {};
        let gradesMapById = {};

        try {
            const rawGrades = localStorage.getItem("fetchGradesOfSelectedAssignment");
            if (rawGrades) {
                const parsed = JSON.parse(rawGrades);
                if (parsed && Array.isArray(parsed.studentsWithGrades)) {
                    parsed.studentsWithGrades.forEach((student) => {
                        if (student.email) gradesMap[student.email.toLowerCase()] = student.score || student.grade || "";
                        if (student.studentId) gradesMapById[student.studentId] = student.score || student.grade || "";
                        if (student.firstName && student.lastName) {
                            gradesMapByName[
                                `${student.firstName} ${student.lastName}`.toLowerCase()
                            ] = student.score || student.grade || "";
                        }
                    });
                }
            }
        } catch (e) {
            console.error("sendingemails3: Error parsing grades:", e);
        }

        const getStudentScore = (student) => {
            const studentEmail = (student?.email || "").trim().toLowerCase();
            if (studentEmail && gradesMap[studentEmail] !== undefined) return gradesMap[studentEmail];

            const studentId = (student?.studentId || student?.studentid || "").toString().trim();
            if (studentId && gradesMapById[studentId] !== undefined) return gradesMapById[studentId];

            const fullName = `${student?.firstName || ""} ${student?.lastName || ""}`.trim().toLowerCase();
            if (fullName && gradesMapByName[fullName] !== undefined) return gradesMapByName[fullName];

            return "{GCAssignment Score}";
        };

        const aggregatedMessages = [];
        const startTime = Date.now();

        const translateText = async (text, targetLang) => {
            if (!text) return "";
            if (!apiKey || !targetLang || targetLang === "en") return text;

            try {
                const resp = await axios.post(
                    `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`,
                    { q: text, source: "en", target: targetLang, format: "text" },
                    { headers: { "Content-Type": "application/json" } }
                );
                return resp?.data?.data?.translations?.[0]?.translatedText ?? text;
            } catch (err) {
                console.warn("Translation call failed, using original text:", err);
                return text;
            }
        };

        const hasNamePlaceholder = templateWithoutLinks.includes("{Student Name}");
        const hasScorePlaceholder = templateWithoutLinks.includes("{GCAssignment Score}");

        if (hasNamePlaceholder || hasScorePlaceholder) {
            console.log("sendingemails3: Template has placeholders - personalizing BEFORE translation");

            const allStudents = studentsToUse.map(normalizeStudent);
            const studentsByLang = {};

            for (const student of allStudents) {
                const code = (
                    student?.parentlanguagecode ||
                    student?.parentLanguageCode ||
                    student?.lang ||
                    "en"
                ).toString().trim().toLowerCase();

                if (!studentsByLang[code]) studentsByLang[code] = [];
                studentsByLang[code].push(student);
            }

            const langPromises = Object.entries(studentsByLang).map(async ([lang, langStudents]) => {
                console.log(`sendingemails3: Processing ${langStudents.length} students for lang='${lang}'`);
                const msgs = [];

                for (const student of langStudents) {
                    const name = student?.localfirstname || student?.firstName || student?.first_name || "";
                    const gender = student?.gender ?? "she";

                    let personalizedBody = templateWithoutLinks;
                    if (hasNamePlaceholder) {
                        personalizedBody = personalizedBody.replaceAll("{Student Name}", name);
                    }
                    if (hasScorePlaceholder) {
                        const score = getStudentScore(student);
                        personalizedBody = personalizedBody.replaceAll("{GCAssignment Score}", score);
                    }

                    console.log(`sendingemails3: Personalized message for ${name}:`, personalizedBody);

                    let translatedBody = personalizedBody;
                    if (lang && lang !== "en") {
                        translatedBody = await translateText(personalizedBody, lang);
                    }

                    translatedBody = reinjectLinks(translatedBody, extractedLinks);
                    const bodyWithPronouns = replacePronouns(translatedBody, gender);

                    const parentEmails = extractParentEmails(student);
                    const link = buildStudentLinkLocal(student);
                    const finalBody = link ? `${bodyWithPronouns}\n\n${link}` : bodyWithPronouns;
                    const sid = getFirebaseStudentIdentifier(student);
                    const googleid = getGoogleStudentIdentifier(student);

                    for (const addr of parentEmails) {
                        if (addr && addr.toString().trim()) {
                            msgs.push({
                                to: addr,
                                subject: globalSubject,
                                body: finalBody,
                                studentId: sid,
                                googleid,
                                recipientType: "parent",
                                parentemail: addr.toString().trim(),
                            });
                        }
                    }
                }

                console.log(`sendingemails3: built ${msgs.length} personalized+translated msgs for lang='${lang}'`);
                return msgs;
            });

            try {
                const results = await Promise.all(langPromises);
                for (const result of results) {
                    if (Array.isArray(result) && result.length > 0) {
                        aggregatedMessages.push(...result);
                    }
                }
            } catch (err) {
                console.error("sendingemails3 error in personalize+translate:", err);
            }
        } else {
            console.log("sendingemails3: No placeholders - translating template per language");

            const translationPromises = langs.map(async (langRaw) => {
                const lang = (langRaw || "en").toString().trim().toLowerCase();
                console.log(`sendingemails3: processing lang='${lang}'`);

                let translated = templateWithoutLinks;
                if (lang && lang !== "en") {
                    translated = await translateText(templateWithoutLinks, lang);
                }

                translated = reinjectLinks(translated, extractedLinks);

                const studentsForLang = studentsToUse.map(normalizeStudent).filter((student) => {
                    const code = (
                        student?.parentlanguagecode ||
                        student?.parentLanguageCode ||
                        student?.lang ||
                        "en"
                    ).toString().trim().toLowerCase();

                    return code === lang || (lang === "en" && !student?.parentlanguagecode && !student?.parentLanguageCode && !student?.lang);
                });

                const targetStudents =
                    studentsForLang.length > 0
                        ? studentsForLang
                        : lang === "en"
                            ? studentsToUse.map(normalizeStudent)
                            : [];

                const msgs = buildMessagesFromTemplate(translated, targetStudents, {
                    linkLevel: locallinklevel,
                    studentLinks,
                    subject: globalSubject,
                    recipientMode,
                });

                console.log(`sendingemails3: built ${msgs.length} group msgs for lang='${lang}'`);
                return msgs;
            });

            try {
                const results = await Promise.all(translationPromises);
                for (const result of results) {
                    if (Array.isArray(result) && result.length > 0) {
                        aggregatedMessages.push(...result);
                    }
                }
            } catch (err) {
                console.error("sendingemails3 error in translate:", err);
            }
        }

        if (aggregatedMessages.length < 1) {
            console.log("sendingemails3: no messages after processing — trying fallback build");
            const fallback = buildMessagesFromTemplate(originalTemplate, studentsToUse, {
                linkLevel: locallinklevel,
                studentLinks,
                subject: globalSubject,
                recipientMode,
            });
            if (fallback.length > 0) aggregatedMessages.push(...fallback);
        }

        console.log(
            "sendingemails3: total aggregatedMessages:",
            aggregatedMessages.length,
            "duration(ms):",
            Date.now() - startTime
        );

        setThesearethemessages2(aggregatedMessages);
        return aggregatedMessages;
    }

    useEffect(() => {
        console.log("[Notifications] Button visibility check:", {
            towhom,
            localdescription,
            notificationsCount: Array.isArray(notifications) ? notifications.length : 0,
            willShowLoadNotificationsButton:
                (towhom === "" || !towhom) &&
                localdescription === "" &&
                Array.isArray(notifications) &&
                notifications.length > 0,
        });
    }, [towhom, localdescription, notifications]);

    useEffect(() => {
        const parseJsonOrRaw = (value, fallback = null) => {
            if (value === null || typeof value === "undefined" || value === "") {
                return fallback;
            }

            try {
                return JSON.parse(value);
            } catch (err) {
                return value;
            }
        };

        const qp = new URLSearchParams(location.search);

        const hasEmailCallbackData =
            qp.has("emailSendFlowCompleted") ||
            qp.has("emailSendStatus") ||
            qp.has("emailSendAlert") ||
            qp.has("modalMessage") ||
            qp.has("alert") ||
            qp.has("emailSent") ||
            qp.has("success");

        if (!hasEmailCallbackData) {
            return;
        }

        const emailSentPayload = parseJsonOrRaw(qp.get("emailSent"), null);

        const flowCompleted =
            String(parseJsonOrRaw(qp.get("emailSendFlowCompleted"), "false")).toLowerCase() === "true";

        const statusFromUrl = String(parseJsonOrRaw(qp.get("emailSendStatus"), "")).toLowerCase();
        const statusFromPayload =
            typeof emailSentPayload?.success === "boolean"
                ? (emailSentPayload.success ? "success" : "failure")
                : "";
        const legacySuccess =
            String(parseJsonOrRaw(qp.get("success"), "false")).toLowerCase() === "true";

        const status =
            statusFromUrl ||
            statusFromPayload ||
            (legacySuccess ? "success" : "") ||
            (flowCompleted ? "success" : "unknown");

        const senderEmail = String(
            parseJsonOrRaw(
                qp.get("emailSendSender"),
                parseJsonOrRaw(qp.get("senderEmail"), emailSentPayload?.senderEmail || "")
            ) || ""
        );

        const requestedCount = parseJsonOrRaw(
            qp.get("emailSendRequested"),
            parseJsonOrRaw(qp.get("requestedCount"), emailSentPayload?.requestedCount ?? null)
        );

        const sentCount = parseJsonOrRaw(
            qp.get("emailSendSucceeded"),
            parseJsonOrRaw(qp.get("sentCount"), emailSentPayload?.sentCount ?? null)
        );

        const failedCount = parseJsonOrRaw(
            qp.get("emailSendFailed"),
            parseJsonOrRaw(qp.get("failedCount"), emailSentPayload?.failedCount ?? null)
        );

        const sentFolderConfirmedCount = parseJsonOrRaw(
            qp.get("emailSendSentFolderConfirmed"),
            parseJsonOrRaw(qp.get("sentFolderConfirmedCount"), emailSentPayload?.sentFolderConfirmedCount ?? null)
        );

        const sentFolderUnverifiedCount = parseJsonOrRaw(
            qp.get("emailSendSentFolderUnverified"),
            parseJsonOrRaw(qp.get("sentFolderUnverifiedCount"), emailSentPayload?.sentFolderUnverifiedCount ?? null)
        );

        const failedRecipientsRaw = parseJsonOrRaw(
            qp.get("failedRecipients"),
            emailSentPayload?.failedRecipients || []
        );

        const failedRecipients = Array.isArray(failedRecipientsRaw)
            ? failedRecipientsRaw
            : (failedRecipientsRaw ? [failedRecipientsRaw] : []);

        const modalMessage = String(
            parseJsonOrRaw(
                qp.get("emailSendAlert"),
                parseJsonOrRaw(
                    qp.get("modalMessage"),
                    emailSentPayload?.modalMessage || qp.get("alert") || emailSentPayload?.alert || ""
                )
            ) || ""
        );

        setSendStatus(status === "failure" ? "error" : "sent");
        setBackendModalTitle(status === "failure" ? "Email Send Result" : "Email Sent Successfully");
        setBackendModalMessage(
            modalMessage ||
            (status === "failure"
                ? "The email send flow completed with issues."
                : "Your emails have been processed.")
        );
        setBackendModalDetails({
            flowCompleted,
            status,
            senderEmail,
            requestedCount,
            sentCount,
            failedCount,
            sentFolderConfirmedCount,
            sentFolderUnverifiedCount,
            failedRecipients,
            rawEmailSent: emailSentPayload,
        });
        setIsBackendModalOpen(true);
        setAwaitingConfirmSend(false);

        const paramsToDelete = [
            "emailSendFlowCompleted",
            "emailSendStatus",
            "emailSendSender",
            "emailSendRequested",
            "requestedCount",
            "emailSendSucceeded",
            "sentCount",
            "emailSendFailed",
            "failedCount",
            "emailSendSentFolderConfirmed",
            "sentFolderConfirmedCount",
            "emailSendSentFolderUnverified",
            "sentFolderUnverifiedCount",
            "failedRecipients",
            "emailSendAlert",
            "modalMessage",
            "alert",
            "emailSent",
            "senderEmail",
            "success",
        ];

        const cleaned = new URLSearchParams(location.search);
        paramsToDelete.forEach((key) => cleaned.delete(key));

        const nextSearch = cleaned.toString();
        const nextUrl = `${location.pathname}${nextSearch ? `?${nextSearch}` : ""}`;
        window.history.replaceState({}, document.title, nextUrl);
    }, [location.pathname, location.search]);

    // ...existing code...
    // ...existing code...
    useEffect(() => {
        if (!showPreparedMessages && !awaitingConfirmSend) return;

        const timer = setTimeout(async () => {
            try {
                if (towhom === "Students") {
                    const prepared = await sendingemails3students(students);
                    setThesearethemessages2(Array.isArray(prepared) ? prepared : []);
                    return;
                }

                if (towhom === "Parents") {
                    const prepared = await sendingemails3(students);
                    setThesearethemessages2(Array.isArray(prepared) ? prepared : []);
                    return;
                }

                if (towhom === "Both") {
                    const [parentMsgs, studentMsgs] = await Promise.all([
                        sendingemails3(students),
                        sendingemails3students(students),
                    ]);

                    const allMsgs = [...(parentMsgs || []), ...(studentMsgs || [])];
                    const uniqueMsgs = allMsgs.filter(
                        (msg, idx, arr) =>
                            msg?.to &&
                            arr.findIndex(m => m.to === msg.to && m.body === msg.body) === idx
                    );

                    setThesearethemessages2(uniqueMsgs);
                    return;
                }

                await prepareMessagesOnly();
            } catch (e) {
                console.error("preview refresh failed:", e);
            }
        }, 400);

        return () => clearTimeout(timer);
    }, [
        showPreparedMessages,
        awaitingConfirmSend,
        towhom,
        studentLinks,
        locallinklevel,
        localclassid,
        localteacherid,
        students,
        localdescription,
        parentlanguagecodes
    ]);
    // ...existing code...

    // language: javascript
    // filepath: /Users/Matt/Desktop/fastclasspassforweb/frontend/src/Components/Messageforsending.js
    // ...existing code.
    // ...existing code...

    const addStudentscore = () => {
        setLocaldescription(prev => (prev || "") + " {GCAssignment Score} ");
    };

    // FIRST: Fetch user data and set infoforsending to localStorage
    // FIRST: Fetch user data and set infoforsending to localStorage
    // Replace the useEffect that fetches user data (around line ~255-330) with this:

    // Replace the fetchUserData useEffect (around line ~255-330) with this:

    useEffect(() => {
        if (!id) {
            console.log("fetchUserData: No id present, skipping");
            return;
        }

        const fetchUserData = async () => {
            try {
                console.log("=== fetchUserData START ===");
                console.log("Fetching user doc for id:", id);

                const userRef = doc(firebase, "users", id);
                const userSnap = await getDoc(userRef);

                if (!userSnap.exists()) {
                    console.log("❌ User document not found for id:", id);
                    return;
                }

                const userData = userSnap.data();
                console.log("✅ User document found, keys:", Object.keys(userData));

                const { currentclass, currentclassname, currentlocation, fetchGradesOfSelectedAssignment } = userData || {};
                console.log("User data extracted:", {
                    currentclass,
                    currentclassname,
                    currentlocation,
                    hasFetchGradesOfSelectedAssignment: !!fetchGradesOfSelectedAssignment
                });

                // Save fetchGradesOfSelectedAssignment to localStorage
                if (fetchGradesOfSelectedAssignment) {
                    console.log("✅ fetchGradesOfSelectedAssignment EXISTS, saving to localStorage");
                    localStorage.setItem("fetchGradesOfSelectedAssignment", JSON.stringify(fetchGradesOfSelectedAssignment));
                } else {
                    console.log("❌ fetchGradesOfSelectedAssignment is MISSING or empty in user document");
                }

                // Load the class doc if currentclass exists
                if (currentclass) {
                    console.log("Fetching class doc for currentclass:", currentclass);

                    const classRef = doc(firebase, "classesbeingtaught", currentclass);
                    const classSnap = await getDoc(classRef);

                    if (!classSnap.exists()) {
                        console.log("❌ Class document not found for id:", currentclass);
                        return;
                    }

                    const classData = classSnap.data();
                    console.log("✅ Class document found, keys:", Object.keys(classData));

                    if (classData.Attachmentchoice) {
                        setAttachmentchoice(classData.Attachmentchoice);
                        console.log("✅ Attachmentchoice loaded from class doc:", classData.Attachmentchoice);
                    }

                    const { low, high } = normalizeEmailScoreRange(
                        classData.valuetosendornotsentemails ?? 0,
                        classData.valuetosendornotsentemailshigh ?? 100
                    );
                    setValueToSendOrNotSentEmails(String(low));
                    setValueToSendOrNotSentEmailsHigh(String(high));
                    console.log("✅ Apply Filter thresholds loaded from class doc:", {
                        classId: currentclass,
                        valuetosendornotsentemails: classData.valuetosendornotsentemails ?? 0,
                        valuetosendornotsentemailshigh: classData.valuetosendornotsentemailshigh ?? 100,
                        normalizedLow: low,
                        normalizedHigh: high,
                    });

                    setSelectedclass(classData);

                    const studentIds = classData.studentIds || classData.students || [];
                    const studentArray = Array.isArray(studentIds) ? studentIds : [];

                    console.log("studentIds from classData:", {
                        count: studentArray.length,
                        firstFew: studentArray.slice(0, 3)
                    });

                    // Save full student list to localStorage as backup
                    localStorage.setItem("infoforsending", JSON.stringify(studentArray));
                    console.log("✅ Full student list saved to localStorage (infoforsending)");

                    // --- NEW: Check for filtered student list (infoforsending2) ---
                    let studentsToUse = studentArray;
                    try {
                        const infoforsending2Raw = localStorage.getItem("infoforsending2");
                        const infoforsending2timesent = localStorage.getItem("infoforsending2timesent");

                        console.log("Checking for filtered students:", {
                            hasInfoforsending2: !!infoforsending2Raw,
                            hasTimesent: !!infoforsending2timesent,
                            timesent: infoforsending2timesent
                        });

                        if (infoforsending2Raw && infoforsending2timesent) {
                            const timeSent = parseInt(infoforsending2timesent, 10);
                            const now = Date.now();
                            // 🟢 INCREASED: Changed from 20 minutes (1.2M ms) to 2 hours (7.2M ms)
                            const TwoHoursAgo = now - 7200000;

                            console.log("Time check (2-hour window):", {
                                timeSent,
                                now,
                                TwoHoursAgo,
                                minutesOld: Math.round((now - timeSent) / 60000),
                                isRecent: timeSent > TwoHoursAgo
                            });

                            if (timeSent > TwoHoursAgo) {
                                // infoforsending2 was set within the last 2 hours - use it
                                const filteredStudents = JSON.parse(infoforsending2Raw);
                                if (Array.isArray(filteredStudents) && filteredStudents.length > 0) {
                                    studentsToUse = filteredStudents;
                                    console.log("✅ Using FILTERED student list (infoforsending2):", {
                                        count: filteredStudents.length,
                                        firstFew: filteredStudents.slice(0, 3)
                                    });
                                } else {
                                    console.log("⚠️ infoforsending2 is empty or not an array, using full list");
                                }
                            } else {
                                console.log("⚠️ infoforsending2timesent is older than 2 hours, using full list");
                                // Clear stale filtered data (older than 2 hours)
                                localStorage.removeItem("infoforsending2");
                                localStorage.removeItem("infoforsending2timesent");
                            }
                        } else {
                            console.log("ℹ️ No filtered student list found, using full list");
                        }
                    } catch (filterErr) {
                        console.warn("⚠️ Error checking infoforsending2, using full list:", filterErr);
                        // Continue with full student list
                    }

                    // Set students - either filtered or full list
                    setStudents(studentsToUse);
                    console.log("✅ Students set:", studentsToUse.length, "students");

                } else {
                    console.log("❌ currentclass is MISSING in user document");
                }

                console.log("=== fetchUserData END ===");
            } catch (err) {
                console.error("❌ fetchUserData error:", err);
            }
        };

        fetchUserData();
    }, [id]);
    // SECOND: Read the freshly-set infoforsending from localStorage

    // Prefer passed state studentIds, otherwise safely parse localStorage "myclasses" and extract its studentIds array

    // Replace the studentLinks useEffect (around line ~345-400) with this:


    const renderEmailReportModal = () => {
        if (!emailReportModalVisible) {
            return null;
        }

        const statusLabel =
            emailSendStatus === "failure"
                ? "Failure"
                : emailSendStatus === "unknown"
                    ? "Unknown"
                    : "Success";

        const statusColor =
            emailSendStatus === "failure"
                ? "#ff0000"
                : emailSendStatus === "unknown"
                    ? "#ffff00"
                    : "#00FF00";

        return (
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(0,0,0,0.65)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 99999,
                    padding: 16,
                }}
            >
                <div
                    style={{
                        width: "min(720px, 96vw)",
                        background: "#111",
                        color: "#fff",
                        borderRadius: 18,
                        padding: 24,
                        boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
                        border: "4px solid #e43522",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 12,
                            marginBottom: 14,
                        }}
                    >
                        <h2 style={{ margin: 0, fontSize: 28 }}>Email Delivery Report</h2>
                        <div
                            style={{
                                padding: "8px 12px",
                                borderRadius: 999,
                                background: `${statusColor}22`,
                                color: statusColor,
                                fontWeight: 700,
                            }}
                        >
                            {statusLabel}
                        </div>
                    </div>

                    {emailModalMessage ? (
                        <p style={{ marginTop: 0, marginBottom: 18, color: "#d7d7d7", lineHeight: 1.5 }}>
                            {emailModalMessage}
                        </p>
                    ) : null}

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                            gap: 12,
                            marginBottom: 18,
                        }}
                    >
                        <div style={{ background: "#1a1a1a", borderRadius: 12, padding: 14 }}>
                            <div style={{ color: "#9aa0a6", fontSize: 13 }}>Requested</div>
                            <div style={{ fontSize: 24, fontWeight: 700 }}>
                                {emailCountsNotReported.requested ? "Not reported" : emailRequestedCount}
                            </div>
                        </div>

                        <div style={{ background: "#1a1a1a", borderRadius: 12, padding: 14 }}>
                            <div style={{ color: "#9aa0a6", fontSize: 13 }}>Sent</div>
                            <div style={{ fontSize: 24, fontWeight: 700, color: "#00FF00" }}>
                                {emailCountsNotReported.sent ? "Not reported" : emailSentCountAnimated}
                                {emailCountsNotReported.sent ? "" : ` / ${emailSentCountTarget}`}
                            </div>
                        </div>

                        <div style={{ background: "#1a1a1a", borderRadius: 12, padding: 14 }}>
                            <div style={{ color: "#9aa0a6", fontSize: 13 }}>Failed</div>
                            <div style={{ fontSize: 24, fontWeight: 700, color: "#ff0000" }}>
                                {emailCountsNotReported.failed ? "Not reported" : emailFailedCount}
                            </div>
                        </div>


                    </div>

                    <div
                        style={{
                            background: "#171717",
                            borderRadius: 12,
                            padding: 14,
                            marginBottom: 18,
                        }}
                    >
                        <div style={{ color: "#9aa0a6", fontSize: 13, marginBottom: 6 }}>Sent From</div>
                        <div style={{ fontSize: 16, fontWeight: 600 }}>
                            {emailSenderAccount || "Unknown account"}
                        </div>
                        <p style={{ marginTop: 10, marginBottom: 0, color: "#c9c9c9", lineHeight: 1.5 }}>
                            {emailSentCountTarget === 1
                                ? "This email should appear in the sent folder of this account shortly."
                                : "These emails should appear in the sent folder of this account shortly."}
                        </p>
                    </div>

                    {Array.isArray(emailFailedRecipients) && emailFailedRecipients.length > 0 ? (
                        <div
                            style={{
                                background: "#221616",
                                border: "1px solid rgba(255,107,107,0.25)",
                                borderRadius: 12,
                                padding: 14,
                                marginBottom: 18,
                            }}
                        >
                            <div style={{ color: "#ff9b9b", fontWeight: 700, marginBottom: 8 }}>
                                Failed Recipients
                            </div>
                            <div style={{ color: "#f0d5d5", lineHeight: 1.6 }}>
                                {emailFailedRecipients.join(", ")}
                            </div>
                        </div>
                    ) : null}

                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <button
                            onClick={() => setEmailReportModalVisible(false)}
                            style={{
                                padding: "10px 16px",
                                borderRadius: 10,
                                border: "none",
                                background: "#0a84ff",
                                color: "#fff",
                                fontSize: 16,
                                cursor: "pointer",
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        if (!students.length) {
            setStudentLinks({});
            return;
        }

        if (locallinklevel === 0) {
            // No links needed - just clear
            setStudentLinks({});
            return;
        }


        console.log("Building studentLinks for", students.length, "students");

        const host = "https://fastclasspass.web.app";
        const out = {};

        const parseStringStudent = (str) => {
            if (!str || typeof str !== "string") return {};
            const t = str.trim();
            if (t.startsWith("{") || t.startsWith("[")) {
                try { return JSON.parse(str); } catch (e) { /* fallthrough */ }
            }
            const obj = {};
            const parts = str.split(/,(?=\s*[A-Za-z0-9_])/);
            for (const p of parts) {
                const idx = p.indexOf(":");
                if (idx === -1) continue;
                const key = p.slice(0, idx).trim().replace(/(^['"]|['"]$)/g, "");
                let val = p.slice(idx + 1).trim().replace(/^[\(\[\{]\s*/, '').replace(/\s*[\)\]\}]$/, '').trim();
                if (val.startsWith("[") || val.includes("','") || val.includes('","')) {
                    obj[key] = val.replace(/^\[|\]$/g, '').split(/[,;]+/).map(x => x.replace(/['"\s]/g, '').trim()).filter(Boolean);
                } else {
                    obj[key] = val.replace(/^['"]|['"]$/g, '').trim();
                }
            }
            return obj;
        };

        for (const raw of students) {
            const s = (typeof raw === "string") ? parseStringStudent(raw) : (raw || {});
            const studentId = (s.firebasestudentid || s.studentId || s.studentid || s.id || "").toString();
            const classId = (localclassid || "").toString();
            const teacherId = (localteacherid || id || "").toString();
            const lang = (s.parentlanguagecode || s.parentLanguageCode || "en").toString().trim() || "en";

            if (!studentId) continue;
            if (locallinklevel === 1 && classId && teacherId) {
                out[studentId] = `${host}/only2studentid/${encodeURIComponent(studentId)}/${encodeURIComponent(classId)}/id/${encodeURIComponent(teacherId)}/language/${encodeURIComponent(lang)}`;
            } else if (locallinklevel === 2 && classId && teacherId) {
                out[studentId] = `${host}/studentid/${encodeURIComponent(studentId)}/${encodeURIComponent(classId)}/id/${encodeURIComponent(teacherId)}/language/${encodeURIComponent(lang)}`;
            } else {
                out[studentId] = "";
            }
        }

        setStudentLinks(out);
        console.log("studentLinks updated:", Object.keys(out).length, "entries");
    }, [students, locallinklevel, localclassid, localteacherid, id]);

    useEffect(() => {
        const codes = new Set();

        for (const item of students) {
            if (!item) continue;
            let s = item;
            if (typeof item === "string") {
                try {
                    s = JSON.parse(item);
                } catch (e) {
                    continue;
                }
            }
            const code = (s?.parentlanguagecode || s?.parentLanguageCode || "").toString().trim();
            if (code) codes.add(code);
        }

        const parentLanguageCodes = Array.from(codes);
        setParentLanguageCodes(parentLanguageCodes);
        console.log("Unique parentlanguagecode values:", parentLanguageCodes);
    }, [students]);

    function renderBodyWithLinks(body) {
        console.log("Rendering body with links:", body);
        // Replace {Link|text|url} tokens with anchor tags
        return body.split(/(\{Link\|[^|}]+\|[^|}]+\})/g).map((part, idx) => {
            const match = part.match(/^\{Link\|([^|}]+)\|([^|}]+)\}$/);
            if (match) {
                const [_, text, url] = match;
                // Normalize URL: add https:// if no protocol is present
                const normalizedUrl = url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//') ? url : `https://${url}`;
                return (
                    <a
                        key={idx}
                        href={normalizedUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#0a84ff", textDecoration: "underline" }}
                    >
                        {text}
                    </a>
                );
            }
            return part;
        });
    }



    useEffect(() => {
        try {
            console.log("Updated parentlanguagecodes:", parentlanguagecodes, "Updated parentlanguagecodes:");
        } catch (err) {
            console.warn("Error collecting parentlanguagecode from passedTemparray", err);
        }
    }, [parentlanguagecodes]);


    const activeid = location.state?.activeid || localStorage.getItem("activeid") || "123";

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    async function getAllKeys() {
        // 🔴 CRITICAL FIX: Don't use localStorage.clear() - it destroys infoforsending2
        // Instead, selectively remove only auth-related keys
        const keysToRemove = [
            'id', 'id2', 'firstname', 'firstname2', 'lastname', 'lastname2',
            'role', 'role2', 'school', 'school2', 'town', 'town2',
            'state', 'state2', 'email', 'email2', 'phone', 'phone2',
            'activeid', 'access_token', 'refresh_token', 'expiry_date'
        ];

        // PRESERVE these keys during logout
        const preserveKeys = ['infoforsending2', 'infoforsending2timesent'];

        console.log('🧹 Selective localStorage cleanup (preserving filtered student list)');
        keysToRemove.forEach(key => {
            localStorage.removeItem(key);
        });

        const keys = Object.keys(localStorage);
        console.log('✅ Remaining keys after cleanup:', keys);
        checkhowmany(keys);
    }


    const checkhowmany = (keys) => {
        console.log(keys, "here are the keys");
        if (keys.length < 1) {
            console.log("There are NOT keys");
        } else {
            console.log("There are keys here");
        }
    };

    const auth = getAuth();

    const signoutfunction = () => {
        console.log('🔐 Signing out - preserving filtered student list if present');
        const filteredStudents = localStorage.getItem("infoforsending2");
        const filteredTimesent = localStorage.getItem("infoforsending2timesent");

        setShowspinner(false);
        getAllKeys();

        // 🟢 CRITICAL FIX: Restore filtered student list after cleanup
        if (filteredStudents && filteredTimesent) {
            localStorage.setItem("infoforsending2", filteredStudents);
            localStorage.setItem("infoforsending2timesent", filteredTimesent);
            console.log('✅ Restored filtered student list after logout');
        }

        setEmaillocal("");
        setPasswordlocal("");
        setRole("");
        setId("");
        auth.signOut();
    };


    const handleChange4 = (value) => {
        setNewdescriptiontobesaved(value);
    };
    const addStudentname = (value) => {
        setLocaldescription(prev => (prev || "") + " {Student Name} ");
    };

    const addLink = (target = "local") => {
        setLinkModalTarget(target);
        setLinkFrontText("");
        setLinkHref("");
        setIsLinkModalOpen(true);
    };

    // ...existing code...
    async function prepareMessagesOnly() {
        console.log("prepareMessagesOnly called, towhom:", towhom);

        try {
            if (towhom === "Students") {
                const studentMsgs = await sendingemails3students(students);
                const out = Array.isArray(studentMsgs) ? studentMsgs : [];
                setThesearethemessages2(out);
                return out;
            }

            if (towhom === "Parents") {
                const parentMsgs = await sendingemails3(students);
                const out = Array.isArray(parentMsgs) ? parentMsgs : [];
                setThesearethemessages2(out);
                return out;
            }

            if (towhom === "Both") {
                const [parentMsgs, studentMsgs] = await Promise.all([
                    sendingemails3(students),
                    sendingemails3students(students),
                ]);

                const all = [
                    ...(Array.isArray(parentMsgs) ? parentMsgs : []),
                    ...(Array.isArray(studentMsgs) ? studentMsgs : []),
                ];

                const unique = all.filter(
                    (msg, idx, arr) =>
                        msg?.to &&
                        arr.findIndex(
                            m => m.to === msg.to && m.subject === msg.subject && m.body === msg.body
                        ) === idx
                );

                setThesearethemessages2(unique);
                return unique;
            }

            setThesearethemessages2([]);
            return [];
        } catch (err) {
            console.error("prepareMessagesOnly error:", err);
            setThesearethemessages2([]);
            return [];
        }
    }
    // ...existing code...

    const makeRawMessage = ({ to, subject, body }) => {
        const message =
            "To: " + to + "\r\n" +
            "Subject: " + subject + "\r\n" +
            "Content-Type: text/plain; charset=utf-8\r\n" +
            "\r\n" +
            (body || "");
        // base64url
        const utf8Bytes = new TextEncoder().encode(message);
        let binary = "";
        const chunkSize = 0x8000;
        for (let i = 0; i < utf8Bytes.length; i += chunkSize) {
            binary += String.fromCharCode.apply(null, Array.from(utf8Bytes.subarray(i, i + chunkSize)));
        }
        let base64 = btoa(binary);
        // urlsafe
        return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    };

    // send via Gmail API (frontend)
    const sendViaGmail = async ({ to, subject, body }) => {
        if (!gapiRef.current || !window.gapi.client) {
            throw new Error("Google API client not initialized");
        }
        const currentToken = window.gapi.client.getToken && window.gapi.client.getToken().access_token;
        if (!currentToken) {
            throw new Error("User not signed in to Google (no access token)");
        }
        const raw = makeRawMessage({ to, subject, body });
        const res = await window.gapi.client.gmail.users.messages.send({
            userId: "me",
            resource: { raw },
        });
        return res;
    };

    async function runcheckonemail() {
        console.log("Checking email:", emaillocal);
        if (
            emaillocal.length > 0 &&
            emaillocal.includes("@") &&
            emaillocal.includes(".")
        ) {
            const f = query(
                collection(firebase, "users"),
                where("email", "==", emaillocal)
            );

            const snapshot1 = await getCountFromServer(f);
            const totalCount = snapshot1.data().count;


            if (totalCount < 1) {
                setNothingfound(true);
                console.log(emaillocal, "and",
                    "No user found with this email",
                    "Please check the email address and try again."
                );


            } else if (totalCount === 1) {
                console.log("User found with this email:", emaillocal);

                const querySnapshot = await getDocs(f);

                querySnapshot.forEach((doc) => {

                    if (doc.data().role == "Student") {
                        console.log(doc.data().email, "This is the email");
                        setNothingfound(true);
                        setPersonaldata(doc.data());
                    }
                    if (doc.data().passwordactual == "'Sign Up' Needed") {
                        console.log("User needs to sign up");

                        navigate("/Signup2", { state: { userData: doc.data() } });

                    } else {
                        console.log("User has already signeed up")
                    }
                });

            } else {
                // Get all docs with .role == "Student" and .passwordactual == "'Sign Up' Needed"
                const querySnapshot = await getDocs(f);
                let studentSignUpNeededDocs = [];
                // Check if any doc does NOT have passwordactual === "'Sign Up' Needed"
                let docToKeep = null;
                querySnapshot.forEach((docSnap) => {
                    if (
                        docSnap.data().role === "Student" &&
                        docSnap.data().passwordactual === "'Sign Up' Needed"
                    ) {
                        studentSignUpNeededDocs.push(docSnap);
                    } else if (
                        docSnap.data().role === "Student" &&
                        docSnap.data().passwordactual !== "'Sign Up' Needed"
                    ) {
                        docToKeep = docSnap;
                    }
                });

                if (docToKeep) {
                    // Delete all docs in studentSignUpNeededDocs
                    for (const docToDelete of studentSignUpNeededDocs) {
                        await deleteDoc(doc(firebase, "users", docToDelete.id));
                    }
                    // Do not navigate to Signup2
                } else {
                    // Delete all but one doc in studentSignUpNeededDocs
                    while (studentSignUpNeededDocs.length > 1) {
                        const docToDelete = studentSignUpNeededDocs.pop();
                        await deleteDoc(doc(firebase, "users", docToDelete.id));
                    }
                    // If the last remaining doc has passwordactual == "'Sign Up' Needed", navigate to Signup2
                    if (
                        studentSignUpNeededDocs.length === 1 &&
                        studentSignUpNeededDocs[0].data().passwordactual === "'Sign Up' Needed"
                    ) {
                        navigate("/Signup2", { state: { userData: studentSignUpNeededDocs[0].data() } });
                    }
                }


            }
        }
    }

    useEffect(() => {
        if (
            emaillocal.length > 0 &&
            emaillocal.includes("@") &&
            emaillocal.includes(".")
        ) {
            runcheckonemail();
        }
    }, [emaillocal]);

    useEffect(() => {
        auth.signOut();
    }, []);

    useEffect(() => {
        setShowspinner(false);
    }, []);

    const authObj = getAuth();

    // Set up auth state listener
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(authObj, (user) => {
            if (user) {
                setsomeoneisloggedin(true);
                if (user.email === emaillocal) {
                    console.log("active email", user.email);
                    const uid = user.uid;
                    setId(uid);
                }
            } else {
                setsomeoneisloggedin(false);
                setId("");
                setRole("");
            }
        });

        // Clean up the listener
        return () => unsubscribe();
    }, [emaillocal]);

    useEffect(() => {
        console.log("Here is id", id2);
        if (id2) {
            console.log(id2, "Was just registered for notifications");
            getinfo();
        }
    }, [id2]);


    useEffect(() => {
        console.log("Here is selectedclass", selectedclass);
        if (selectedclass) {
            // Extract and set local state from selectedclass
            console.log("classid", selectedclass.id, "teacherid", selectedclass.teacherid, selectedclass.additionallinklevel);
            setLocalclassid(selectedclass.id);
            setLocalteacherid(selectedclass.teacherid);
            setLocalcoursename(selectedclass.classname);
            setLocalschoolname(selectedclass.school);
            setLocalteachername(selectedclass.teacheriscalled);

            if (typeof selectedclass.additionallinklevel === "undefined" || selectedclass.additionallinklevel === "") {
                setLocallinklevel(0);
            } else {
                setLocallinklevel(selectedclass.additionallinklevel);
            }
        }
        // NOTE: Removed the localStorage reading - students are now loaded in fetchUserData
    }, [selectedclass]);

    useEffect(() => {
        if (!emailScoreThresholdClassId) {
            setValueToSendOrNotSentEmails("0");
            setValueToSendOrNotSentEmailsHigh("100");
            return;
        }

        let cancelled = false;

        const loadEmailScoreThresholdSettings = async () => {
            try {
                const classSnapshot = await getDoc(doc(firebase, "classesbeingtaught", emailScoreThresholdClassId));

                if (!classSnapshot.exists()) {
                    if (!cancelled) {
                        setValueToSendOrNotSentEmails("0");
                        setValueToSendOrNotSentEmailsHigh("100");
                    }
                    return;
                }

                const classData = classSnapshot.data() || {};
                const { low, high } = normalizeEmailScoreRange(
                    classData.valuetosendornotsentemails ?? 0,
                    classData.valuetosendornotsentemailshigh ?? 100
                );

                if (!cancelled) {
                    setValueToSendOrNotSentEmails(String(low));
                    setValueToSendOrNotSentEmailsHigh(String(high));
                }
            } catch (error) {
                console.error("Failed to load email score threshold settings:", error);
            }
        };

        loadEmailScoreThresholdSettings();

        return () => {
            cancelled = true;
        };
    }, [emailScoreThresholdClassId]);

    const handleChange2 = (value) => {
        setLocaldescription(value);
    };

    useEffect(() => {
        if (role2) {
            sendaway();
        }
    }, [role2]);

    const makeEmailSubject = () => {
        const school = (locaschoolname || "").toString().trim();
        const teacher = (localteachername || "").toString().trim();
        const course = (localcoursename || "").toString().trim();

        // build parts and avoid awkward punctuation if parts missing
        const parts = [];
        if (school) parts.push(school);
        if (teacher) parts.push(teacher);
        const left = parts.join(" - ");
        const subject = left ? `${left} (${course || ""})` : (course ? `(${course})` : "Message from FastClassPass");
        // clean double spaces/empty parentheses
        return subject.replace(/\s+/g, " ").replace(/\(\s*\)/, "").trim();
    };

    const getinfo = () => {
        const docRef = doc(firebase, "users", id2);
        const docData = getDoc(docRef).then((docSnap) => {
            if (docSnap.exists()) {
                if (docSnap.data().adminclass) {
                    localStorage.setItem("adminclass", docSnap.data().adminclass);
                    console.log("there was a adminclass");
                } else {
                    console.log("there was not an adminclass");
                }
                if (docSnap.data().teacheriscalled) {
                    localStorage.setItem(
                        "teacheriscalled",
                        docSnap.data().teacheriscalled
                    );
                    console.log("there was a teacheriscalled");
                } else {
                    console.log("there was not a teachers is called");
                }

                if (docSnap.data().localfirstname) {
                    localStorage.setItem("firstname", docSnap.data().localfirstname);
                    console.log("there was a firstnaame", docSnap.data().localfirstname);
                } else {
                    console.log("there was not a firstname is called");
                }

                if (docSnap.data().locallastname) {
                    localStorage.setItem("lastname", docSnap.data().locallastname);
                    console.log("there was a lastname", docSnap.data().locallastname);
                } else {
                    console.log("there was not a lastname is called");
                }
                if (docSnap.data().role) {
                    localStorage.setItem("role", docSnap.data().role);
                    console.log("there was a role", docSnap.data().role);
                } else {
                    console.log("there was not a role is called");
                }
                if (docSnap.data().id) {
                    localStorage.setItem("id", docSnap.data().id);
                    console.log("there was an id", docSnap.data().id);
                } else {
                    console.log("there was not an id called");
                }
                if (docSnap.data().school) {
                    localStorage.setItem("school", docSnap.data().school);
                    console.log("there was an school", docSnap.data().school);
                } else {
                    console.log("there was not a school called");
                }
                if (docSnap.data().town) {
                    localStorage.setItem("town", docSnap.data().town);
                    console.log("there was an town", docSnap.data().town);
                } else {
                    console.log("there was not a town called");
                }
                if (docSnap.data().state) {
                    localStorage.setItem("state", docSnap.data().state);
                    console.log("there was an state", docSnap.data().state);
                } else {
                    console.log("there was not a state called", docSnap.data().state);
                }
                if (docSnap.data().email) {
                    localStorage.setItem("email", docSnap.data().email);
                    console.log("there was an email", docSnap.data().email);
                    setEmail(docSnap.data().email);
                } else {
                    console.log("there was not a email called", docSnap.data().email);
                }

                if (docSnap.data().phonenumber) {
                    localStorage.setItem("phonenumber", docSnap.data().phonenumber);
                    setPhone2(docSnap.data().phonenumber);
                    console.log("there was a phone number", docSnap.data().phonenumber);
                } else {
                    console.log("there was not a phone number called");
                    localStorage.setItem("phonenumber", "None Listed");
                    setPhone2("None Listed");
                }

                setEmail(docSnap.data().email);
                setSchool(docSnap.data().school);
                setTown(docSnap.data().town);
                setState(docSnap.data().state);
                setFirstname(docSnap.data().localfirstname);
                setLastname(docSnap.data().locallastname);
                setPhone2(docSnap.data().phonenumber);

                setTeacheriscalled(docSnap.data().teacheriscalled);
                setEmaillocal("");
                setPasswordlocal("");
                setRole(docSnap.data().role);
            } else {
                alert(
                    'The user "Document" cannot be found. The user needs to recreate the account.'
                );
            }
        });
    };

    const sendaway = () => {
        if (role2 === "Student") {
            setShowspinner(false);

            console.log("this is the id in signup.", id2, school2, town2, state2, role2, firstname2, lastname2, email2, phone2);


            navigate(newidforstudent1, { state: { personaldata } });

        }
        if (role2 === "Teacher") {
            setShowspinner(false);

            navigate(newidforteacher, { state: { id2, school2, town2, state2, role2, teacheriscalled2, email2 } });

        }
        if (role2 === "Admin") {
            setShowspinner(false);

            navigate(adminaddress, { state: { id2, school2, state2, town2, schoolid } });

        } else {
            console.log("This is the role", role2, "Slow your role");
        }
    };

    const go = () => {
        navigation.navigate("Mainmenustudent", {
            school2: school2,
            state2: state2,
            town2: town2,
            role2: role2,
            firstname2: firstname2,
            lastname2: lastname2,
            id2: id2,
            email2: email2,
            phone2: phone2,
        });
    };

    useEffect(() => {
        const loadPreviousEmails = () => {
            try {
                const storedEmails = localStorage.getItem('previousEmails');
                if (storedEmails) {
                    const emails = JSON.parse(storedEmails);
                    setPreviousEmails(emails);

                    // Auto-fill the most recent email
                    if (emails.length > 0) {
                        setEmaillocal(emails[0]);
                    }
                }
            } catch (error) {
                console.error('Error loading previous emails:', error);
            }
        };

        loadPreviousEmails();
    }, []);

    useEffect(() => {
        if (emaillocal && previousEmails.length > 0) {
            const filtered = previousEmails.filter(
                email => email.toLowerCase().includes(emaillocal.toLowerCase())
            );
            setFilteredEmails(filtered);
        } else {
            setFilteredEmails([]);
        }
    }, [emaillocal, previousEmails]);

    async function startPrepareAndSendToBoth(event) {
        if (event && typeof event.preventDefault === "function") {
            event.preventDefault();
        }
        if (!students.length) {
            alert("No students loaded. check email for details of missing state");
            return;
        }
        const template = (localdescription || "").trim();
        if (!template) {
            alert("Message body is empty.");
            return;
        }

        // Build parent messages (with links)
        let parentMsgs = [];
        try {
            parentMsgs = await sendingemails3(students); // your parent message builder
        } catch (e) {
            console.error("Error building parent messages:", e);
        }

        // Build student messages (no links)
        let studentMsgs = [];
        try {
            studentMsgs = await buildMessagesForStudents(template, students);
        } catch (e) {
            console.error("Error building student messages:", e);
        }

        // Combine and dedupe by "to" address
        const allMsgs = [...parentMsgs, ...studentMsgs];
        // Keep both parent and student messages even if 'to' is the same, as long as the body is different
        const uniqueMsgs = allMsgs.filter((msg, idx, arr) => {
            if (!msg.to) return false;
            // Only filter out exact duplicates (same to, same body)
            return arr.findIndex(m => m.to === msg.to && m.body === msg.body) === idx;
        });

        if (!uniqueMsgs.length) {
            alert("No messages prepared to send.");
            return;
        }

        setThesearethemessages2(uniqueMsgs);
        setAwaitingConfirmSend(true);
        setShowPreparedMessages(true);
    }

    const parseJsonOrRaw = (value, fallback = "") => {
        if (typeof value === "undefined" || value === null || value === "") {
            return fallback;
        }
        if (typeof value !== "string") {
            return value;
        }

        let decoded = value;
        try {
            decoded = decodeURIComponent(value);
        } catch (e) {
            decoded = value;
        }

        try {
            return JSON.parse(decoded);
        } catch (e) {
            return decoded;
        }
    };

    const collectCallbackParams = (search) => {
        const qp = {};

        const addParamsFromString = (paramString) => {
            if (typeof paramString !== "string" || paramString.length === 0) {
                return;
            }

            const normalized = paramString.startsWith("?") ? paramString.slice(1) : paramString;
            const sp = new URLSearchParams(normalized);

            for (const [key, value] of sp.entries()) {
                if (typeof qp[key] === "undefined") {
                    qp[key] = value;
                }
            }
        };

        addParamsFromString(search);

        const outer = new URLSearchParams(search);
        const nestedUrl = outer.get("url");
        if (typeof nestedUrl === "string" && nestedUrl.includes("?")) {
            const nestedQuery = nestedUrl.split("?")[1].split("#")[0];
            addParamsFromString(nestedQuery);
        }

        return qp;
    };

    const parseEmailResultFromSearch = (search) => {
        try {
            const qp = collectCallbackParams(search);

            const hasEmailCallbackData =
                typeof qp.emailSendFlowCompleted !== "undefined" ||
                typeof qp.emailSendStatus !== "undefined" ||
                typeof qp.emailSendAlert !== "undefined" ||
                typeof qp.modalMessage !== "undefined" ||
                typeof qp.alert !== "undefined" ||
                typeof qp.emailSent !== "undefined" ||
                typeof qp.success !== "undefined";

            if (!hasEmailCallbackData) {
                return null;
            }

            const emailSentPayload = parseJsonOrRaw(qp.emailSent, null);

            const flowCompleted =
                String(parseJsonOrRaw(qp.emailSendFlowCompleted, "false")).toLowerCase() === "true";

            const statusFromUrl = parseJsonOrRaw(qp.emailSendStatus, null);
            const statusFromPayload =
                typeof emailSentPayload?.success === "boolean"
                    ? emailSentPayload.success
                        ? "success"
                        : "failure"
                    : null;

            const legacySuccess =
                String(parseJsonOrRaw(qp.success, "false")).toLowerCase() === "true";

            const statusRaw = String(
                statusFromUrl || statusFromPayload || (legacySuccess ? "success" : "unknown")
            ).toLowerCase();

            const status =
                statusRaw === "failure"
                    ? "failure"
                    : statusRaw === "success"
                        ? "success"
                        : "unknown";

            const failedRaw = parseJsonOrRaw(qp.failedRecipients, []);
            const failedRecipients = Array.isArray(failedRaw)
                ? failedRaw
                : Array.isArray(emailSentPayload?.failedRecipients)
                    ? emailSentPayload.failedRecipients
                    : typeof failedRaw === "string" && failedRaw.length > 0
                        ? [failedRaw]
                        : [];

            const getCountOrUnreported = (urlParam, fallbackParam, payloadField) => {
                const urlValue = parseJsonOrRaw(urlParam, null);
                if (urlValue !== null) return toSafeNumber(urlValue, 0);

                const fallbackValue = parseJsonOrRaw(fallbackParam, null);
                if (fallbackValue !== null) return toSafeNumber(fallbackValue, 0);

                const payloadValue =
                    payloadField !== null && typeof payloadField !== "undefined"
                        ? payloadField
                        : null;
                if (payloadValue !== null) return toSafeNumber(payloadValue, 0);

                return "Not reported";
            };

            const requestedCount = getCountOrUnreported(
                qp.emailSendRequested,
                qp.requestedCount,
                emailSentPayload?.requestedCount
            );

            const sentCount = getCountOrUnreported(
                qp.emailSendSucceeded,
                qp.sentCount,
                emailSentPayload?.sentCount
            );

            const failedCount = getCountOrUnreported(
                qp.emailSendFailed,
                qp.failedCount,
                emailSentPayload?.failedCount
            );

            const sentFolderConfirmedCount = getCountOrUnreported(
                qp.emailSendSentFolderConfirmed,
                qp.sentFolderConfirmedCount,
                emailSentPayload?.sentFolderConfirmedCount
            );

            const sentFolderUnverifiedCount = getCountOrUnreported(
                qp.emailSendSentFolderUnverified,
                qp.sentFolderUnverifiedCount,
                emailSentPayload?.sentFolderUnverifiedCount
            );

            return {
                flowCompleted,
                status,
                success: status === "success",
                senderEmail: String(
                    parseJsonOrRaw(
                        qp.emailSendSender,
                        parseJsonOrRaw(qp.senderEmail, emailSentPayload?.senderEmail || "")
                    )
                ),
                requestedCount,
                sentCount,
                failedCount,
                sentFolderConfirmedCount,
                sentFolderUnverifiedCount,
                failedRecipients,
                modalMessage: String(
                    parseJsonOrRaw(
                        qp.emailSendAlert,
                        parseJsonOrRaw(
                            qp.modalMessage,
                            emailSentPayload?.modalMessage || qp.alert || emailSentPayload?.alert || ""
                        )
                    )
                ),
                alert: String(parseJsonOrRaw(qp.alert, emailSentPayload?.alert || "")),
            };
        } catch (error) {
            console.error("Failed parsing email result search:", error);
            return null;
        }
    };

    const openEmailReportModal = (payload) => {
        const statusDisplay =
            payload?.status === "failure"
                ? "failure"
                : payload?.status === "unknown"
                    ? "unknown"
                    : "success";

        setEmailSendStatus(statusDisplay);
        setEmailSenderAccount(payload?.senderEmail || "");

        const countsNotReported = {
            requested: payload?.requestedCount === "Not reported",
            sent: payload?.sentCount === "Not reported",
            failed: payload?.failedCount === "Not reported",
            sentFolderConfirmed: payload?.sentFolderConfirmedCount === "Not reported",
            sentFolderUnverified: payload?.sentFolderUnverifiedCount === "Not reported",
        };

        setEmailCountsNotReported(countsNotReported);
        setEmailRequestedCount(
            payload?.requestedCount === "Not reported" ? 0 : toSafeNumber(payload?.requestedCount, 0)
        );
        setEmailSentCountTarget(
            payload?.sentCount === "Not reported" ? 0 : toSafeNumber(payload?.sentCount, 0)
        );
        setEmailSentCountAnimated(0);
        setEmailFailedCount(
            payload?.failedCount === "Not reported" ? 0 : toSafeNumber(payload?.failedCount, 0)
        );
        setEmailSentFolderConfirmedCount(
            payload?.sentFolderConfirmedCount === "Not reported"
                ? 0
                : toSafeNumber(payload?.sentFolderConfirmedCount, 0)
        );
        setEmailSentFolderUnverifiedCount(
            payload?.sentFolderUnverifiedCount === "Not reported"
                ? 0
                : toSafeNumber(payload?.sentFolderUnverifiedCount, 0)
        );
        setEmailFailedRecipients(Array.isArray(payload?.failedRecipients) ? payload.failedRecipients : []);
        setEmailModalMessage(payload?.modalMessage || payload?.alert || "");
        setEmailReportModalVisible(true);
    };

    const openLocalEmailErrorModal = (message, detailMessage = "") => {
        openEmailReportModal({
            status: "failure",
            senderEmail: "",
            requestedCount: "Not reported",
            sentCount: "Not reported",
            failedCount: "Not reported",
            sentFolderConfirmedCount: "Not reported",
            sentFolderUnverifiedCount: "Not reported",
            failedRecipients: [],
            modalMessage: detailMessage || message,
            alert: message,
        });
    };

    useEffect(() => {
        const payload = parseEmailResultFromSearch(location.search);

        if (!payload) {
            return;
        }

        const hydrateAndOpen = async () => {
            let hydratedPayload = { ...payload };
            try {
                const userSnap = await getDoc(doc(firebase, "users", id));
                if (userSnap.exists()) {
                    const userData = userSnap.data() || {};
                    const report =
                        userData?.emailSendReportPayload &&
                        typeof userData.emailSendReportPayload === "object"
                            ? userData.emailSendReportPayload
                            : {};
                    const fsFailedRecipients = Array.isArray(userData?.failedRecipients)
                        ? userData.failedRecipients
                        : Array.isArray(report?.failedRecipients)
                        ? report.failedRecipients
                        : [];
                    const normalizeStatus = (v) => {
                        const s = String(v || "unknown").toLowerCase();
                        return s === "success" || s === "failure" ? s : "unknown";
                    };
                    const pickCount = (cur, rep) => {
                        if (cur !== "Not reported") return cur;
                        return typeof rep === "undefined" || rep === null ? "Not reported" : rep;
                    };
                    const mergedStatus =
                        payload.status && payload.status !== "unknown"
                            ? payload.status
                            : normalizeStatus(report?.emailSendStatus);
                    hydratedPayload = {
                        ...payload,
                        flowCompleted:
                            payload.flowCompleted === true ||
                            String(report?.emailSendFlowCompleted || "false").toLowerCase() === "true",
                        status: mergedStatus,
                        senderEmail: payload.senderEmail || String(report?.emailSendSender || ""),
                        requestedCount: pickCount(payload.requestedCount, report?.emailSendRequested),
                        sentCount: pickCount(payload.sentCount, report?.emailSendSucceeded),
                        failedCount: pickCount(payload.failedCount, report?.emailSendFailed),
                        sentFolderConfirmedCount: pickCount(payload.sentFolderConfirmedCount, report?.emailSendSentFolderConfirmed),
                        sentFolderUnverifiedCount: pickCount(payload.sentFolderUnverifiedCount, report?.emailSendSentFolderUnverified),
                        failedRecipients:
                            Array.isArray(payload.failedRecipients) && payload.failedRecipients.length > 0
                                ? payload.failedRecipients
                                : fsFailedRecipients,
                        modalMessage: payload.modalMessage || String(report?.emailSendAlert || ""),
                    };
                }
            } catch (fsErr) {
                console.warn("Failed to hydrate email result from Firestore:", fsErr);
            }

            setSendStatus(hydratedPayload.status === "failure" ? "error" : "sent");
            setAwaitingConfirmSend(false);
            openEmailReportModal(hydratedPayload);

            const paramsToDelete = [
                "emailSendFlowCompleted",
                "emailSendStatus",
                "emailSendSender",
                "emailSendRequested",
                "requestedCount",
                "emailSendSucceeded",
                "sentCount",
                "emailSendFailed",
                "failedCount",
                "emailSendSentFolderConfirmed",
                "sentFolderConfirmedCount",
                "emailSendSentFolderUnverified",
                "sentFolderUnverifiedCount",
                "failedRecipients",
                "emailSendAlert",
                "modalMessage",
                "alert",
                "emailSent",
                "senderEmail",
                "success",
                "url",
            ];

            const cleaned = new URLSearchParams(location.search);
            paramsToDelete.forEach((key) => cleaned.delete(key));

            const nextSearch = cleaned.toString();
            const nextUrl = `${location.pathname}${nextSearch ? `?${nextSearch}` : ""}`;
            window.history.replaceState({}, document.title, nextUrl);
        };

        hydrateAndOpen();
    }, [location.pathname, location.search]);

    useEffect(() => {
        if (!emailReportModalVisible) {
            return;
        }

        const target = toSafeNumber(emailSentCountTarget, 0);
        if (target <= 0) {
            setEmailSentCountAnimated(0);
            return;
        }

        const totalAnimationMs = 1800;
        const stepMs = Math.max(40, totalAnimationMs / target);

        let current = 0;
        const timer = window.setInterval(() => {
            current += 1;
            setEmailSentCountAnimated(current);
            if (current >= target) {
                window.clearInterval(timer);
            }
        }, stepMs);

        return () => window.clearInterval(timer);
    }, [emailReportModalVisible, emailSentCountTarget]);

    // Handler for "Send to Students" button
    async function startPrepareAndSendToStudents(event) {
        console.log("3HERE ARE THE MESSAGES - the one that should run towhom:", towhom, localdescription);

        if (event && typeof event.preventDefault === "function") {
            event.preventDefault();
        }
        if (!students.length) {
            alert("No students loaded. check email for details of missing state");
            return;
        }

        // Decide whether translation step is needed based on students' languagecode
        const studentLangs = Array.isArray(students)
            ? students.map(s => (s.languagecode || s.languageCode || "en").toString().trim().toLowerCase())
            : [];
        const needTranslation = studentLangs.some(lang => lang !== "en");

        let prepared = [];
        // Split students into those needing translation and those not
        const studentsNeedingTranslation = students.filter(s => {
            const lang = (s.languagecode || s.languageCode || "en").toString().trim().toLowerCase();
            return lang !== "en";
        });
        const studentsNoTranslation = students.filter(s => {
            const lang = (s.languagecode || s.languageCode || "en").toString().trim().toLowerCase();
            return lang === "en";
        });

        let translatedMsgs = [];
        let regularMsgs = [];

        if (studentsNeedingTranslation.length > 0) {
            console.log(
                "5HERE ARE THE MESSAGES: Translation needed for these students:",
                studentsNeedingTranslation.map(s => ({
                    email: s.email,
                    languagecode: s.languagecode || s.languageCode,
                    firstName: s.firstName,
                    lastName: s.lastName,
                    studentId: s.studentId || s.firebasestudentid
                })),
                "localdescription:", localdescription
            );
            console.log("7HERE ARE THE MESSAGES: Translated messages:", studentsNeedingTranslation);
            translatedMsgs = await sendingemails3students(studentsNeedingTranslation);
            console.log("8HERE ARE THE MESSAGES: Translated messages:", translatedMsgs);
        }

        if (studentsNoTranslation.length > 0) {
            const template = (localdescription || "").trim();
            if (!template) {
                alert("Message body is empty.");
                return;
            }
            console.log("6HERE ARE THE MESSAGESCalling buildMessagesForStudents, students:", studentsNoTranslation, "template:", template, localdescription);
            regularMsgs = await buildMessagesForStudents(template, studentsNoTranslation);
        }

        prepared = [...translatedMsgs, ...regularMsgs];
        if (!prepared.length) {
            alert("No student messages prepared to send.");
            return;
        }
        setThesearethemessages2(prepared);
        setAwaitingConfirmSend(true);
        setShowPreparedMessages(true);
    }

    // Build messages for students (no links, use student email/languagecode, translate if needed)
    async function buildMessagesForStudents(template, students, options = {}) {

        const resolvedTemplate = resolveAssignmentNameTokens(template);
        console.log("4HERE ARE THE MESSAGESbuildMessagesForStudents: students:", students, "template:", resolvedTemplate, localdescription);
        const msgs = [];
        if (!resolvedTemplate) return msgs;

        // Helper for score lookup (copied from buildMessagesFromTemplate)
        let gradesMap = {};
        let gradesMapByName = {};
        let gradesMapById = {};
        try {
            const rawGrades = localStorage.getItem("fetchGradesOfSelectedAssignment");
            if (rawGrades) {
                const parsedGrades = JSON.parse(rawGrades);
                if (parsedGrades && Array.isArray(parsedGrades.studentsWithGrades)) {
                    parsedGrades.studentsWithGrades.forEach((s) => {
                        if (s.email) gradesMap[s.email.trim().toLowerCase()] = s.grade;
                        const name = (s.name || "").trim().toLowerCase();
                        if (name) gradesMapByName[name] = s.grade;
                        const gid = (s.id || "").toString().trim();
                        if (gid) gradesMapById[gid] = s.grade;
                    });
                }
            }
        } catch (e) { }

        function getStudentScore(student) {
            const studentEmail = (student?.email || "").trim().toLowerCase();
            if (studentEmail && gradesMap[studentEmail] !== undefined) return gradesMap[studentEmail];
            const studentId = (student?.studentId || student?.studentid || "").toString().trim();
            if (studentId && gradesMapById[studentId] !== undefined) return gradesMapById[studentId];
            const fullName = `${student?.firstName || ""} ${student?.lastName || ""}`.trim().toLowerCase();
            if (fullName && gradesMapByName[fullName] !== undefined) return gradesMapByName[fullName];
            return "{GCAssignment Score}";
        }

        for (const rawStudent of students) {
            // Normalize student object if needed
            const student = typeof rawStudent === "string"
                ? (() => { try { return JSON.parse(rawStudent); } catch { return {}; } })()
                : rawStudent;



            // Only ever use student.email for the 'to' field, never parentemail
            const email = student?.email || "";
            if (!email && student?.parentemail) {
                console.warn("[buildMessagesForStudents] Skipping student with parentemail fallback. Only student.email is allowed for student messages.", student);
            }
            if (!email) continue;

            let body = resolvedTemplate;

            // Substitute {Student Name}
            const name = student?.localfirstname || student?.firstName || student?.first_name || "";
            if (body.includes("{Student Name}")) {
                body = body.replaceAll("{Student Name}", name);
            }
            // Substitute {GCAssignment Score}
            if (body.includes("{GCAssignment Score}")) {
                const score = getStudentScore(student);
                body = body.replaceAll("{GCAssignment Score}", score);
            }

            // If skipTranslate is set, do not translate here (translation handled in prepareMessagesOnly)
            if (!options.skipTranslate) {
                const lang = (student?.languagecode || student?.languageCode || "en").toString().trim().toLowerCase();
                if (lang && lang !== "en" && typeof window !== "undefined" && window.axios) {
                    try {
                        const apiKey = process.env.REACT_APP_GOOGLE_API_KEY || "";
                        if (apiKey) {
                            const resp = await window.axios.post(
                                `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`,
                                { q: body, source: "en", target: lang, format: "text" },
                                { headers: { "Content-Type": "application/json" } }
                            );
                            body = resp?.data?.data?.translations?.[0]?.translatedText ?? body;
                        }
                    } catch (err) {
                        console.warn("Translation call failed, using original text:", err);
                    }
                }
            }

            // No links for students
            const msgObj = {
                to: email,
                subject: typeof makeEmailSubject === "function" ? makeEmailSubject() : "Message from FastClassPass",
                body,
                studentId: getFirebaseStudentIdentifier(student),
                googleid: getGoogleStudentIdentifier(student),
                languagecode: student?.languagecode || student?.languageCode || "en",
                recipientType: "student"
            };
            console.log(`[buildMessagesForStudents] Built message:`, msgObj);
            msgs.push(msgObj);
        }
        return msgs;
    }

    function buildMessagesFromTemplate(template, students, options = {}) {

        console.log(towhom, " 2HERE ARE THE MESSAGES", students);

        if (towhom !== "Parents" && towhom !== "Both") {
            return [];
        }

        const linkLevel = typeof options.linkLevel !== "undefined" ? options.linkLevel : locallinklevel;
        const linksMap = options.studentLinks || studentLinks;
        const msgs = [];
        if (!template) return msgs;

        const subjectForMessages = options.subject || makeEmailSubject();

        // === DEBUG: Log template and placeholders ===
        console.log("=== buildMessagesFromTemplate START ===");
        console.log("Template:", template);
        console.log("Has {Student Name}:", template.includes("{Student Name}"));
        console.log("Has {GCAssignment Score}:", template.includes("{GCAssignment Score}"));
        console.log("Students count:", Array.isArray(students) ? students.length : 0);

        // Helper to parse student objects
        const safeParseKeyValueString = (str) => {
            const out = {};
            if (!str || typeof str !== "string") return out;
            const parts = str.split(/,(?=\s*[A-Za-z0-9_])/);
            for (let p of parts) {
                const idx = p.indexOf(":");
                if (idx === -1) continue;
                const key = p.slice(0, idx).trim().replace(/(^['"]|['"]$)/g, "");
                let val = p.slice(idx + 1).trim().replace(/^[\(\[\{]\s*/, '').replace(/\s*[\)\]\}]$/, '').trim();
                if (!val) { out[key] = val; continue; }
                if (val.startsWith("[") || val.includes("','") || val.includes('","')) {
                    out[key] = val.replace(/^\[|\]$/g, '').split(/[,;]+/).map(x => x.replace(/['"\s]/g, '').trim()).filter(Boolean);
                } else {
                    out[key] = val.replace(/^['"]|['"]$/g, '').trim();
                }
            }
            return out;
        };

        const normalizeStudent = (s) => {
            if (!s) return {};
            if (typeof s === "string") {
                const t = s.trim();
                if (t.startsWith("{") || t.startsWith("[")) {
                    try { return JSON.parse(s); } catch (e) { /* fallthrough */ }
                } else {
                    const kv = safeParseKeyValueString(s);
                    kv.rawString = s;
                    return kv;
                }
            }
            return s;
        };






        const extractParentEmails = (student) => {

            console.log(towhom, " 1HERE ARE THE MESSAGES", student);

            if (towhom !== "Parents" && towhom !== "Both") {
                return [];
            }

            if (!student || typeof student !== "object") return [];
            const candidates = [
                "parentemail", "parentEmail", "parentemails", "parent_emails",
                "guardianEmail", "guardian_email", "parentEmails", "parents", "contact_email"
            ];
            for (const key of candidates) {
                const val = student[key];
                if (typeof val === "undefined" || val === null) continue;
                if (Array.isArray(val)) return val.map(v => (v || "").toString().trim()).filter(Boolean);
                if (typeof val === "string") {
                    const parts = val.split(/[,;]+/).map(p => p.trim()).filter(Boolean);
                    if (parts.length) return parts;
                }
            }
            if (student.data && typeof student.data === "object") return extractParentEmails(student.data);
            if (student.payload && typeof student.payload === "object") return extractParentEmails(student.payload);
            return [];
        };

        const buildStudentLink = (student) => {
            if (!student) return "";
            const s = (typeof student === "string") ? (() => { try { return JSON.parse(student); } catch (e) { return {}; } })() : student;
            const studentId = (s.firebasestudentid || s.studentId || s.studentid || s.id || "").toString();
            if (studentId && linksMap && typeof linksMap[studentId] !== "undefined") {
                return linksMap[studentId] || "";
            }
            const classId = (localclassid || "").toString();
            const teacherId = (localteacherid || id || "").toString();
            const lang = (s.parentlanguagecode || s.parentLanguageCode || "en").toString().trim() || "en";
            if (!studentId || !classId || !teacherId) return "";
            const host = "https://fastclasspass.web.app";
            if (linkLevel === 1) {
                return `${host}/only2studentid/${encodeURIComponent(studentId)}/${encodeURIComponent(classId)}/id/${encodeURIComponent(teacherId)}/language/${encodeURIComponent(lang)}`;
            }
            if (linkLevel === 2) {
                return `${host}/studentid/${encodeURIComponent(studentId)}/${encodeURIComponent(classId)}/id/${encodeURIComponent(teacherId)}/language/${encodeURIComponent(lang)}`;
            }
            return "";
        };

        // --- Load grades from localStorage ---
        let gradesMap = {};
        let gradesMapByName = {};
        let gradesMapById = {};
        try {
            const rawGrades = localStorage.getItem("fetchGradesOfSelectedAssignment");
            console.log("=== GRADES LOADING ===");
            console.log("fetchGradesOfSelectedAssignment raw:", rawGrades);
            if (rawGrades) {
                const parsedGrades = JSON.parse(rawGrades);
                console.log("fetchGradesOfSelectedAssignment parsed:", parsedGrades);
                console.log("studentsWithGrades array:", parsedGrades?.studentsWithGrades);
                if (parsedGrades && Array.isArray(parsedGrades.studentsWithGrades)) {
                    console.log("studentsWithGrades count:", parsedGrades.studentsWithGrades.length);
                    parsedGrades.studentsWithGrades.forEach((s, idx) => {
                        console.log(`Grade entry [${idx}]:`, { email: s.email, name: s.name, id: s.id, grade: s.grade });
                        if (s.email) {
                            gradesMap[s.email.trim().toLowerCase()] = s.grade;
                        }
                        const name = (s.name || "").trim().toLowerCase();
                        if (name) {
                            gradesMapByName[name] = s.grade;
                        }
                        const gid = (s.id || "").toString().trim();
                        if (gid) {
                            gradesMapById[gid] = s.grade;
                        }
                    });
                } else {
                    console.log("studentsWithGrades is NOT an array or missing");
                }
            } else {
                console.log("fetchGradesOfSelectedAssignment NOT FOUND in localStorage");
            }
        } catch (e) {
            console.error("Error parsing fetchGradesOfSelectedAssignment:", e);
        }

        console.log("=== GRADES MAPS BUILT ===");
        console.log("gradesMap (by email):", gradesMap);
        console.log("gradesMapByName:", gradesMapByName);
        console.log("gradesMapById:", gradesMapById);

        function getStudentScore(student) {
            console.log("=== getStudentScore called ===");
            console.log("Student object:", student);

            const studentEmail = (student?.email || "").trim().toLowerCase();
            console.log("Trying email match:", studentEmail, "exists in gradesMap:", gradesMap[studentEmail] !== undefined);
            if (studentEmail && gradesMap[studentEmail] !== undefined) {
                console.log("✅ Matched grade by student email:", studentEmail, "->", gradesMap[studentEmail]);
                return gradesMap[studentEmail];
            }

            const studentId = (student?.studentId || student?.studentid || "").toString().trim();
            console.log("Trying studentId match:", studentId, "exists in gradesMapById:", gradesMapById[studentId] !== undefined);
            if (studentId && gradesMapById[studentId] !== undefined) {
                console.log("✅ Matched grade by studentId:", studentId, "->", gradesMapById[studentId]);
                return gradesMapById[studentId];
            }

            const fullName = `${student?.firstName || ""} ${student?.lastName || ""}`.trim().toLowerCase();
            console.log("Trying fullName match:", fullName, "exists in gradesMapByName:", gradesMapByName[fullName] !== undefined);
            if (fullName && gradesMapByName[fullName] !== undefined) {
                console.log("✅ Matched grade by fullName:", fullName, "->", gradesMapByName[fullName]);
                return gradesMapByName[fullName];
            }

            console.log("❌ No grade match found for student:", { studentEmail, studentId, fullName });
            return "{GCAssignment Score}";
        }

        // --- Main message building logic ---
        const hasNamePlaceholder = template.includes("{Student Name}");
        const hasScorePlaceholder = template.includes("{GCAssignment Score}");

        console.log("=== BUILDING MESSAGES ===");
        console.log("hasNamePlaceholder:", hasNamePlaceholder);
        console.log("hasScorePlaceholder:", hasScorePlaceholder);

        for (const rawStudent of (Array.isArray(students) ? students : [])) {
            const student = normalizeStudent(rawStudent);
            console.log("Processing student:", student);

            const name = student?.localfirstname || student?.firstName || student?.first_name || "";
            const parentEmails = extractParentEmails(student);
            const gender = student?.gender ?? "she";
            let body = template;

            if (hasNamePlaceholder) {
                body = body.replaceAll("{Student Name}", name);
                console.log("After {Student Name} replacement:", body);
            }
            if (hasScorePlaceholder) {
                const score = getStudentScore(student);
                console.log("Score returned from getStudentScore:", score);
                body = body.replaceAll("{GCAssignment Score}", score);
                console.log("After {GCAssignment Score} replacement:", body);
            }

            body = replacePronouns(body, gender);

            const link = buildStudentLink(student);

            const finalBody = link ? `${body}\n\n${link}` : body;

            // ✅ KEY FIX: Don't append the URL to the body - it will come from studentLinks state instead


            console.log("Final body for student:", finalBody);
            console.log("Parent emails:", parentEmails);

            for (const addr of parentEmails) {
                if (addr && addr.toString().trim()) {
                    const msg = {
                        to: addr.toString().trim(),
                        subject: subjectForMessages,
                        body: finalBody,
                        studentId: getFirebaseStudentIdentifier(student),
                        googleid: getGoogleStudentIdentifier(student),
                        recipientType: "parent",
                        parentemail: addr.toString().trim()
                    };
                    console.log("Adding message:", msg);
                    msgs.push(msg);
                }
            }
        }

        console.log("=== buildMessagesFromTemplate END ===");
        console.log("Total messages built:", msgs.length);
        return msgs;

    }


    function replacePronouns(body, gender) {
        try {
            if (gender === "she") {
                body = body.replaceAll(" he ", " she ")
                    .replaceAll("He ", "She ")
                    .replaceAll(" his ", " her ")
                    .replaceAll("His ", "Her ")
                    .replaceAll(" him ", " her ")
                    .replaceAll(" himself ", " herself ");
            } else {
                body = body.replaceAll(" she ", " he ")
                    .replaceAll("She ", "He ")
                    .replaceAll(" her ", " him ")
                    .replaceAll("Her ", "His ")
                    .replaceAll(" herself ", " himself ");
            }
        } catch (e) { }
        return body;
    }

    const removeMessage = (idx) => {
        const updated = thesearethemessages.filter((_, i) => i !== idx);
        setThesearethemessages(updated);
        console.log("Deleted message at index", idx, "Remaining:", updated.length);
    };

    useEffect(() => {
        console.log("Textarea value (localdescription):", localdescription);
    }, [localdescription]);



    function showMissingAssignmentTitleModal() {
        // Remove any existing modal
        const existing = document.getElementById('missing-assignment-title-modal');
        if (existing) existing.remove();

        // Create modal container
        const modal = document.createElement('div');
        modal.id = 'missing-assignment-title-modal';
        modal.style.position = 'fixed';
        modal.style.top = '0';
        modal.style.left = '0';
        modal.style.width = '100vw';
        modal.style.height = '100vh';
        modal.style.background = 'rgba(0,0,0,0.35)';
        modal.style.display = 'flex';
        modal.style.alignItems = 'center';
        modal.style.justifyContent = 'center';
        modal.style.zIndex = '99999';

        // Create modal content
        const box = document.createElement('div');
        box.style.background = '#fff';
        box.style.padding = '28px 32px';
        box.style.borderRadius = '10px';
        box.style.boxShadow = '0 4px 24px rgba(0,0,0,0.18)';
        box.style.maxWidth = '420px';
        box.style.textAlign = 'center';
        box.style.fontFamily = 'inherit';

        box.innerHTML = `
    <div style="font-size:18px;font-weight:bold;margin-bottom:12px;color:#ff9800;">
      Assignment Title Not Loaded
    </div>
    <div style="font-size:15px;color:#333;margin-bottom:22px;">
      <b>"Assignment Title" has not been loaded.</b><br><br>
      Please ensure you have selected or loaded an assignment before trying to insert its title.
    </div>
    <div style="margin-top:18px;">
      <button id="fcp-modal-close" style="background:#1e88e5;color:#fff;border:none;padding:10px 18px;border-radius:6px;font-size:15px;cursor:pointer;">Close</button>
    </div>
  `;

        modal.appendChild(box);
        document.body.appendChild(modal);

        document.getElementById('fcp-modal-close').onclick = () => modal.remove();
    }

    const addAssignmenttitle = () => {
        const currentAssignmentName = getCurrentAssignmentName();

        console.log("[Assignment Sync] addAssignmenttitle source", {
            incomingSelectedAssignmentName,
            assignmentName,
            resolvedAssignmentName: currentAssignmentName,
        });

        if (currentAssignmentName) {
            setLocaldescription(prev => (prev || "") + ` "${currentAssignmentName}" `);
        } else {
            showMissingAssignmentTitleModal();
        }
    };
    // Replace your entire sendingemails3 function (lines ~1329-1493) with this:










    async function sendingemails3students(studentsOverride) {

        console.log("A9HERE ARE THE MESSAGES [sendingemails3] studentsOverride received:", studentsOverride);
        const globalSubject = makeEmailSubject();
        const originalTemplate = (localdescription || "").trim();
        if (!originalTemplate) {
            alert("Message body is empty.");
            return [];
        }

        const studentsToUse = (Array.isArray(studentsOverride) && studentsOverride.length > 0)
            ? studentsOverride
            : (Array.isArray(students) ? students : []);

        const apiKey = process.env.REACT_APP_GOOGLE_API_KEY || "";

        const extractAndRemoveLinks = (text) => {
            const linkRegex = /\{Link\|[^|}]+\|[^}]+\}/g;
            const links = [];
            let match;
            while ((match = linkRegex.exec(text)) !== null) links.push(match[0]);
            return { textWithoutLinks: text.replace(linkRegex, "{LINK_PLACEHOLDER}"), links };
        };

        const reinjectLinks = (text, links) => {
            let out = text;
            for (const link of links) out = out.replace("{LINK_PLACEHOLDER}", link);
            return out;
        };

        const { textWithoutLinks: templateWithoutLinks, links: extractedLinks } = extractAndRemoveLinks(originalTemplate);

        // score maps
        let gradesMap = {};
        let gradesMapByName = {};
        let gradesMapById = {};
        try {
            const rawGrades = localStorage.getItem("fetchGradesOfSelectedAssignment");
            if (rawGrades) {
                const parsed = JSON.parse(rawGrades);
                if (parsed && Array.isArray(parsed.studentsWithGrades)) {
                    parsed.studentsWithGrades.forEach((s) => {
                        if (s.email) gradesMap[s.email.trim().toLowerCase()] = s.score || s.grade || "";
                        if (s.studentId) gradesMapById[s.studentId] = s.score || s.grade || "";
                        if (s.firstName && s.lastName) {
                            gradesMapByName[`${s.firstName} ${s.lastName}`.toLowerCase()] = s.score || s.grade || "";
                        }
                    });
                }
            }
        } catch (e) {
            console.warn("sendingemails3students: grade parse failed", e);
        }

        const getStudentScore = (student) => {
            const studentEmail = (student?.email || "").trim().toLowerCase();
            if (studentEmail && gradesMap[studentEmail] !== undefined) return gradesMap[studentEmail];
            const studentId = (student?.studentId || student?.studentid || "").toString().trim();
            if (studentId && gradesMapById[studentId] !== undefined) return gradesMapById[studentId];
            const fullName = `${student?.firstName || ""} ${student?.lastName || ""}`.trim().toLowerCase();
            if (fullName && gradesMapByName[fullName] !== undefined) return gradesMapByName[fullName];
            return "{GCAssignment Score}";
        };

        const translateText = async (text, targetLang) => {
            if (!text || !apiKey || !targetLang || targetLang === "en") return text;
            try {
                const resp = await axios.post(
                    `https://translation.googleapis.com/language/translate/v2?key=${apiKey}`,
                    { q: text, source: "en", target: targetLang, format: "text" },
                    { headers: { "Content-Type": "application/json" } }
                );
                return resp?.data?.data?.translations?.[0]?.translatedText ?? text;
            } catch (err) {
                console.warn("sendingemails3students: translation failed", err);
                return text;
            }
        };

        const msgs = [];
        for (const s of studentsToUse) {
            const student = (typeof s === "string")
                ? (() => { try { return JSON.parse(s); } catch { return {}; } })()
                : (s || {});

            const to = (student?.email || "").toString().trim();
            if (!to) continue; // students flow uses student.email only

            const lang = (student?.languagecode || student?.languageCode || "en").toString().trim().toLowerCase();
            const name = student?.localfirstname || student?.firstName || student?.first_name || "";

            let body = templateWithoutLinks;
            if (body.includes("{Student Name}")) body = body.replaceAll("{Student Name}", name);
            if (body.includes("{GCAssignment Score}")) body = body.replaceAll("{GCAssignment Score}", getStudentScore(student));

            body = await translateText(body, lang);
            body = reinjectLinks(body, extractedLinks); // keep custom {Link|text|url} tokens

            msgs.push({
                to,
                subject: globalSubject,
                body,
                studentId: getFirebaseStudentIdentifier(student),
                googleid: getGoogleStudentIdentifier(student),
                languagecode: lang || "en"
            });
        }

        setThesearethemessages2(msgs);
        return msgs;
    }


    async function sendingemails2(opts) {
        let to = "";
        let subject = makeEmailSubject();
        let body = "";
        let studentsOverride = null;
        let recipientMode = towhom;

        if (!opts) {
            body = localdescription || "";
        } else if (typeof opts === "string") {
            body = opts;
        } else if (opts && typeof opts === "object" && typeof opts.preventDefault === "function") {
            body = localdescription || "";
        } else if (typeof opts === "object") {
            to = opts.to || "";
            subject = opts.subject || subject;
            body = opts.body || localdescription || "";
            studentsOverride = opts.students || null;
            recipientMode = opts.recipientMode || recipientMode;
        }

        body = resolveAssignmentNameTokens(body);

        if (!body || body.trim() === "") {
            alert("Message body is empty.");
            return [];
        }

        const studentsToUse =
            Array.isArray(studentsOverride) && studentsOverride.length > 0
                ? studentsOverride
                : students;

        console.log("sendingemails2: using students count:", studentsToUse.length);

        try {
            const template = body;
            const subj = makeEmailSubject();

            let messages = buildMessagesFromTemplate(template, studentsToUse, {
                subject: subj,
                recipientMode,
            });

            if ((!messages || messages.length === 0) && to) {
                messages = [{ to, subject: makeEmailSubject(), body: template }];
            }

            setThesearethemessages2(messages);
            return messages;
        } catch (err) {
            console.error("sendingemails2 error constructing messages:", err);
            alert("Failed to prepare messages for sending.");
            return [];
        }
    }

    // Replace startPrepareAndSend function (around line ~1567-1620) with this:

    async function startPrepareAndSend(event) {
        if (event && typeof event.preventDefault === "function") {
            event.preventDefault();
        }

        const recipientMode = "Parents";
        setTowhom(recipientMode);

        console.log("=== DEBUG: FULL STATE CHAIN ===");
        console.log("location.state:", location?.state);
        console.log("arrivedFromMainMenu:", arrivedFromMainMenu);
        console.log("incomingState:", incomingState);
        console.log("incomingSelectedClass:", incomingSelectedClass);
        console.log("incomingTemparray:", incomingTemparray);
        console.log("id (from useParams):", id);
        console.log("id2 (state):", id2);
        console.log("role:", role);
        console.log("role2 (state):", role2);
        console.log("selectedclass:", selectedclass);
        console.log("localclassid:", localclassid);
        console.log("activename:", activename);

        try {
            console.log(
                "localStorage.infoforsending length:",
                JSON.parse(localStorage.getItem("infoforsending") || "[]").length
            );
            console.log(
                "localStorage.infoforsending2 exists:",
                !!localStorage.getItem("infoforsending2")
            );
            console.log(
                "localStorage.infoforsending2timesent:",
                localStorage.getItem("infoforsending2timesent")
            );
            console.log("localStorage.myclasses exists:", !!localStorage.getItem("myclasses"));
        } catch (e) {
            console.error("Error reading localStorage:", e);
        }

        console.log("students.length:", students?.length || 0);
        console.log("students (sample):", students?.slice(0, 2));
        console.log("parentlanguagecodes:", parentlanguagecodes);
        console.log("locallinklevel:", locallinklevel);
        console.log("localteacherid:", localteacherid);
        console.log("studentLinks keys:", Object.keys(studentLinks || {}).length);
        console.log("localdescription length:", localdescription?.length || 0);
        console.log(
            "localdescription (first 100 chars):",
            localdescription?.substring(0, 100) || "(empty)"
        );
        console.log("=== END DEBUG ===");

        if (!students.length) {
            alert("No students loaded. check email for details of missing state");
            return;
        }

        const template = (localdescription || "").trim();
        if (!template) {
            alert("Message body is empty.");
            return;
        }

        console.log("startPrepareAndSend: using students count:", students.length);

        const codes = Array.isArray(parentlanguagecodes) ? parentlanguagecodes : [];
        const needTranslation = codes.some(
            (code) => code && code.toString().trim().toLowerCase() !== "en"
        );

        let prepared = [];
        if (needTranslation) {
            prepared = await sendingemails3(students, { recipientMode });
        } else {
            prepared = await sendingemails2({ students, recipientMode });
        }

        if ((!Array.isArray(prepared) || prepared.length === 0) && students.length > 0) {
            const missingParentEmail = students.every((student) => {
                const obj =
                    typeof student === "string"
                        ? (() => {
                            try {
                                return JSON.parse(student);
                            } catch {
                                return {};
                            }
                        })()
                        : student || {};

                const keys = [
                    "parentemail",
                    "parentEmail",
                    "parentemails",
                    "parent_emails",
                    "guardianEmail",
                    "guardian_email",
                    "parentEmails",
                    "parents",
                    "contact_email",
                ];

                return !keys.some((key) => {
                    const value = obj[key];
                    if (Array.isArray(value)) return value.length > 0;
                    if (typeof value === "string") return value.trim().length > 0;
                    return false;
                });
            });

            if (missingParentEmail) {
                alert("Selected Students Do Not Have Parent Email on file.");
                return;
            }
        }

        if (!Array.isArray(prepared) || prepared.length === 0) {
            alert("No messages prepared to send.");
            return;
        }

        setThesearethemessages2(prepared);
        setAwaitingConfirmSend(true);
        setShowPreparedMessages(true);
    }



    // Modal JSX for backend response (must be defined at top level, not inside a function)
    const BackendResponseModal = () => (
        isBackendModalOpen ? (
            <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                background: "rgba(0,0,0,0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 99999
            }}>
                <div style={{
                    background: "#000",
                    color: "#fff",
                    padding: "32px 24px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
                    textAlign: "center",
                    minWidth: "260px",
                    maxWidth: "90vw"
                }}>
                    <div style={{ fontSize: "1.2rem", fontWeight: "bold", marginBottom: 20, color: "#fff" }}>{backendModalTitle}</div>
                    <div style={{ fontSize: "1rem", marginBottom: 16 }}>{backendModalMessage}</div>
                    {backendModalDetails && (
                        <pre style={{
                            background: "#111",
                            color: "#0f0",
                            padding: "12px",
                            borderRadius: "8px",
                            textAlign: "left",
                            maxHeight: "200px",
                            overflow: "auto",
                            marginBottom: 16
                        }}>{JSON.stringify(backendModalDetails, null, 2)}</pre>
                    )}
                    <button
                        style={{
                            margin: "8px",
                            padding: "10px 18px",
                            fontSize: "1rem",
                            borderRadius: "6px",
                            border: "none",
                            background: "#0a84ff",
                            color: "#fff",
                            cursor: "pointer"
                        }}
                        onClick={() => setIsBackendModalOpen(false)}
                    >
                        Close
                    </button>
                </div>
            </div>
        ) : null
    );

    const getFirebaseStudentIdentifier = (student) => (
        student?.firebasestudentid || student?.id || null
    );

    const getGoogleStudentIdentifier = (student) => (
        student?.studentId || student?.studentid || student?.googleclassroomid || null
    );

    const getAttachmentRequestMetadata = () => {
        const selection = getCurrentAssignmentSelection();

        console.log("[Assignment Sync] sendEmail attachment metadata resolved:", {
            courseId: selection.courseId || "",
            assignmentId: selection.assignmentId || "",
            assignmentName: selection.assignmentName || "",
            assignmentIdFromUrl: assignmentIdFromUrl || "",
            incomingSelectedAssignmentId: incomingSelectedAssignmentId || "",
            source: selection.source || "none",
        });

        logEmailFlow("attachment-selection-resolved", {
            courseId: selection.courseId || "",
            assignmentId: selection.assignmentId || "",
            assignmentName: selection.assignmentName || "",
            assignmentIdFromUrl: assignmentIdFromUrl || "",
            incomingSelectedAssignmentId: incomingSelectedAssignmentId || "",
            includeGoogleAssignmentAttachment,
            source: selection.source || "none",
        });

        return {
            courseId: selection.courseId,
            assignmentId: selection.assignmentId,
            assignmentName: selection.assignmentName,
        };
    };

    const buildMessagesForBackend = (messages) => {
        const baseMessages = Array.isArray(messages) ? messages : [];

        if (!includeGoogleAssignmentAttachment) {
            return baseMessages;
        }

        return baseMessages.map((message) => {
            const { studentId, ...rest } = message || {};
            return {
                ...rest,
                googleid: message?.googleid || null,
            };
        });
    };

    const buildSendEmailState = (messages, options = {}) => {
        const { redactSensitive = false } = options;
        const accessToken = localStorage.getItem("access_token") || "";
        const refreshToken = localStorage.getItem("refresh_token") || "";
        const expiryDate = localStorage.getItem("expiry_date") || "";
        const currentUrl = window.location.href;
        const redirectUrl = `${window.location.origin}${location.pathname}${location.search || ""}`;
        const preparedMessages = buildMessagesForBackend(messages);
        const { courseId, assignmentId, assignmentName } = getAttachmentRequestMetadata();

        const stateObj = {
            id,
            currentUrl,
            task: "sendEmail",
            Attachmentchoice: attachmentchoice,
            redirectUrl,
            subject: makeEmailSubject(),
            studentLinks: studentLinks || {},
            locallinklevel,
            localclassid,
            localteacherid: localteacherid || id,
            email: email2 || localStorage.getItem("email") || "",
            selectedAssignmentName: assignmentName,
            assignmentId,
        };

        if (courseId) {
            stateObj.courseId = courseId;
        }

        if (includeGoogleAssignmentAttachment) {
            stateObj.includeGoogleAssignmentAttachment = true;
            if (courseId) {
                stateObj.courseId = courseId;
            }
        }

        if (!redactSensitive) {
            return stateObj;
        }

        return {
            ...stateObj,
            accessToken: accessToken ? "[redacted]" : "",
            refreshToken: refreshToken ? "[redacted]" : "",
            expiryDate: expiryDate ? "[redacted]" : "",
        };
    };

    async function sendingemails(opts, messagesOverride) {
        const messagesWithLinks = Array.isArray(messagesOverride)
            ? messagesOverride
            : (Array.isArray(thesearethemessages) ? thesearethemessages : []);
        const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";

        logEmailFlow("start", {
            classid: localclassid || classid || "",
            hasValueArray: Array.isArray(messagesWithLinks),
            id,
            subjectLen: makeEmailSubject().length,
            valueLen: Array.isArray(messagesWithLinks) ? messagesWithLinks.length : 0,
        });

        if (!Array.isArray(messagesWithLinks) || messagesWithLinks.length === 0) {
            setSendStatus("error");
            openLocalEmailErrorModal("No Emails Prepared", "There were no messages ready to send.");
            return { success: false, error: "No messages prepared" };
        }

        try {
            logEmailFlow("messages-built", {
                count: messagesWithLinks.length,
            });

            // Save messages to Firestore before the OAuth fetch call
            try {
                logEmailFlow("saving-messages-to-firestore", { messageCount: messagesWithLinks.length });
                await updateDoc(doc(firebase, "users", id), {
                    thesearethemessages: messagesWithLinks,
                });
                logEmailFlow("messages-saved-to-firestore", { messageCount: messagesWithLinks.length });
            } catch (firestoreErr) {
                console.error("Failed to save messages to Firestore:", firestoreErr);
                setSendStatus("error");
                openLocalEmailErrorModal("Email Send Failed", "Failed to prepare emails for sending. Please try again.");
                return { success: false, error: firestoreErr };
            }

            const stateObj = buildSendEmailState(messagesWithLinks);
            logEmailFlow("token-read", {
                teacheremail: maskEmailForLog(stateObj.email || ""),
            });

            const q = `${API_BASE_URL}/api/login?state=${encodeURIComponent(JSON.stringify(stateObj))}`;
            console.log("[ModalDebug] Requesting backend authUrl for sendEmail:", q);
            logEmailFlow("oauth-request-start", {
                endpoint: `${API_BASE_URL}/api/login`,
                messageCount: messagesWithLinks.length,
                queryUrlLen: q.length,
                stateBytes: JSON.stringify(stateObj).length,
            });

            const loginResp = await fetch(q, { method: "GET" });

            if (!loginResp.ok) {
                const txt = await loginResp.text().catch(() => "");
                throw new Error(`Auth request failed ${loginResp.status} ${txt}`);
            }

            const loginData = await loginResp.json();
            console.log("[ModalDebug] /api/login response:", loginData);
            logEmailFlow("oauth-request-success", {
                directExecution: loginData?.directExecution === true,
                hasAuthUrl: !!loginData?.authUrl,
                keys: loginData ? Object.keys(loginData) : [],
            });

            if (loginData && loginData.authUrl) {
                const authUrl =
                    typeof loginData.authUrl === "string" ? loginData.authUrl.trim() : "";

                if (!authUrl || !/^https?:\/\//i.test(authUrl)) {
                    throw new Error(`Invalid authUrl returned from backend: ${authUrl}`);
                }

                setSendStatus("sending");

                // Web flow: redirect the browser to the Google auth URL returned by the backend.
                window.location.href = authUrl;

                return { success: true, redirected: true };
            }

            throw new Error("No authUrl returned from backend");
        } catch (err) {
            console.error("[ModalDebug] Failed to initiate email OAuth/send flow:", err);
            setSendStatus("error");
            openLocalEmailErrorModal(
                "Email Send Failed",
                err?.message || "Failed to initiate Gmail authentication/send flow."
            );
            return { success: false, error: err };
        }
    }
    // ...existing code...

    useEffect(() => {
        if (towhom !== "Parents") {
            return;
        }

        if (!Array.isArray(thesearethemessages) || thesearethemessages.length === 0) {
            return;
        }

        console.log(
            "[Preview] Expected sendEmail payload for backend:",
            buildSendEmailState(thesearethemessages, { redactSensitive: true })
        );
    }, [
        towhom,
        thesearethemessages,
        includeGoogleAssignmentAttachment,
        studentLinks,
        locallinklevel,
        localclassid,
        localteacherid,
        id,
        email2,
        location.pathname,
        location.search,
    ]);

    useEffect(() => {
        console.log(thesearethemessages2, "These are the messages to be sent");
    }, [thesearethemessages2]);

    // ...existing code...



    useEffect(() => {
        // Include all messages, even if there are duplicate 'to' addresses
        // If sending to students, only include messages with a valid student email (never parentemail)
        if (towhom === "Students") {

            const filtered = (Array.isArray(thesearethemessages2) ? thesearethemessages2 : []).filter(
                msg => typeof msg.to === "string" && msg.to.includes("@") && (!msg.parentemail)
            );
            setThesearethemessages(filtered);
            console.log("Filtered student messages (", filtered.length, ") from thesearethemessages2 (", (thesearethemessages2 || []).length, ")");
        } else {
            setThesearethemessages(Array.isArray(thesearethemessages2) ? thesearethemessages2 : []);
            console.log("All thesearethemessages2 (", thesearethemessages2.length, ") -> thesearethemessages (", (thesearethemessages2 || []).length, ")");
        }
    }, [thesearethemessages2]);

    const backendcalltoincludeattachmentsinemail = () => {
        setIncludeGoogleAssignmentAttachment((prev) => {
            const next = !prev;
            console.log(
                `Google assignment attachment requested: ${next ? "true" : "false"}`
            );
            return next;
        });
        setIsOpen11(false);
        setIsOpen12(false);
        setIsOpen13(false);
    };


    const saveLinkToDescription = () => {
        console.log("Saving link to description:", { linkFrontText, linkHref, linkModalTarget });
        if (!linkFrontText || !linkHref) {
            alert("Please provide both link text and URL.");
            return;
        }
        const token = `{Link|${linkFrontText}|${linkHref}}`;

        try {
            // Always update localdescription so textarea reflects the change
            setLocaldescription(prev => {
                const updated = (prev || "") + " " + token + " ";
                console.log("Inserting link token into localdescription:", updated);
                return updated;
            });
            setIsLinkModalOpen(false);
        } catch (err) {
            console.error("Error inserting link token:", err);
            alert("Failed to insert link. See console for details.");
        }
    };


    const previewSelectedSetCount = Array.isArray(thesearethemessages)
        ? new Set(
            thesearethemessages
                .map((message) => {
                    const studentIdentifier = (message?.studentId || "").toString().trim();
                    const googleIdentifier = (message?.googleid || "").toString().trim();

                    if (studentIdentifier) {
                        return `student:${studentIdentifier}`;
                    }

                    if (googleIdentifier) {
                        return `google:${googleIdentifier}`;
                    }

                    return "";
                })
                .filter(Boolean)
        ).size
        : 0;



    console.log(role, id, "This is the role and id in Messageforsending.js");
    return (
        <>
            <div className="App22">

                <NavBar
                    donotshow={donotshow}
                    role={role}
                    sections={sections}
                    setSelectedclass={setSelectedclass}
                    activename={activename}
                    id={id}
                    temparray={students}
                    selectedclass={selectedclass}
                    activeid={activeid}
                    noclasschangeandmainmenuonly={true}

                />
                <>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "12px",
                            width: "100%",
                            marginTop: "20px",
                        }}
                    >
                        <p
                            className="section5922abicon"
                            onClick={() => addStudentname()}
                            data-tooltip-id="my-tooltip-8"
                            onMouseEnter={() => setIsOpen8(true)}
                            onMouseLeave={() => setIsOpen8(false)}
                            style={{ display: "inline-flex", cursor: "pointer", width: "48px", height: "48px", alignItems: "center", justifyContent: "center", fontSize: "36px" }}
                        >
                            🧑‍🎓
                        </p>
                        <p
                            className="section5922abicon"
                            onClick={() => addAssignmenttitle()}
                            data-tooltip-id="my-tooltip-9"
                            onMouseEnter={() => setIsOpen9(true)}
                            onMouseLeave={() => setIsOpen9(false)}
                            style={{ display: "inline-flex", cursor: "pointer", width: "48px", height: "48px", alignItems: "center", justifyContent: "center" }}
                        >
                            <img
                                src="/GCSingleAssignment1.png"
                                alt="Assignment Icon"
                                style={{ width: "48px", height: "48px" }}
                            />
                        </p>

                     

                        <p
                            className="section5922abicon"
                            onClick={() => addStudentscore()}
                            data-tooltip-id="my-tooltip-10"
                            onMouseEnter={() => setIsOpen10(true)}
                            onMouseLeave={() => setIsOpen10(false)}
                            style={{ display: "inline-flex", cursor: "pointer", width: "48px", height: "48px", alignItems: "center", justifyContent: "center" }}
                        >
                            <img
                                src="/GCSingleAssignment2.png"
                                alt="Student Score Icon"
                                style={{ width: "48px", height: "48px" }}
                            />
                        </p>
                        <p
                            className="section5922abicon"
                            onClick={() => addLink("new")}
                            data-tooltip-id="my-tooltip-17"
                            onMouseEnter={() => setIsOpen17(true)}
                            onMouseLeave={() => setIsOpen17(false)}
                            style={{ display: "inline-flex", cursor: "pointer", width: "48px", height: "48px", alignItems: "center", justifyContent: "center", fontSize: "36px" }}
                        >
                            🔗
                        </p>

                           {towhom === "Parents" ? (
                            includeGoogleAssignmentAttachment ? (
                                <p
                                    className="section5922abicon"
                                    onClick={() => backendcalltoincludeattachmentsinemail()}
                                    data-tooltip-id="my-tooltip-11"
                                    onMouseEnter={() => setIsOpen11(true)}
                                    onMouseLeave={() => setIsOpen11(false)}
                                    style={{ display: "inline-flex", cursor: "pointer", width: "48px", height: "48px", alignItems: "center", justifyContent: "center" }}
                                >
                                    <img
                                        src="/AttachAssignments.png"
                                        alt="Assignment Icon"
                                        style={{ width: "48px", height: "48px" }}
                                    />
                                </p>
                            ) : (
                                <p
                                    className="section5922abicon"
                                    onClick={() => backendcalltoincludeattachmentsinemail()}
                                    data-tooltip-id="my-tooltip-12"
                                    onMouseEnter={() => setIsOpen12(true)}
                                    onMouseLeave={() => setIsOpen12(false)}
                                    style={{ display: "inline-flex", cursor: "pointer", width: "48px", height: "48px", alignItems: "center", justifyContent: "center" }}
                                >
                                    <img
                                        src="/DoNotAttachAssignments.png"
                                        alt="Assignment Icon"
                                        style={{ width: "48px", height: "48px" }}
                                    />
                                </p>
                            )
                        ) : null}

                                 {towhom === "Parents" && includeGoogleAssignmentAttachment ? (<p
                                    className="section5922abicon"
                                    onClick={() => changeattachmentchoice()}
                                    data-tooltip-id="my-tooltip-13"
                                    onMouseEnter={() => setIsOpen13(true)}
                                    onMouseLeave={() => setIsOpen13(false)}
                                    style={{ display: "inline-flex", cursor: "pointer", width: "48px", height: "48px", alignItems: "center", justifyContent: "center"}}
                                >
                                   {selectedAttachmentUi.label !== "All attachments" ? (
                                        <img
                                            src={selectedAttachmentUi.image}
                                            alt={selectedAttachmentUi.alt}
                                            style={{ width: "48px", height: "48px" }}
                                        />
                                    ) : "All"}
                                </p>) : towhom === "Parents" ? (<p
                                    className="section5922abicon"
                                    onClick={() => changeattachmentchoice()}
                                    data-tooltip-id="my-tooltip-13"
                                    onMouseEnter={() => setIsOpen13(true)}
                                    onMouseLeave={() => setIsOpen13(false)}
                                    style={{ display: "inline-flex", cursor: "pointer", width: "48px", height: "48px", alignItems: "center", justifyContent: "center", opacity: 0.5 }}
                                >
                                   {selectedAttachmentUi.label !== "All attachments" ? (
                                        <img
                                            src={selectedAttachmentUi.image}
                                            alt={selectedAttachmentUi.alt}
                                            style={{ width: "48px", height: "48px" }}
                                        />
                                    ) : "All"}
                                </p>) : null}
                          

                    </div>
                    <div className="container2" style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>

                        <textarea
                            placehdolder="Description of Entry"
                            placeholdertextcolor="#BEBEBE"
                            value={localdescription} // ...force the input's value to match the state variable...
                            onChange={(f) => handleChange2(f.target.value)}
                            type="text"
                            rows={6}
                            style={{
                                fontSize: "20px",
                                textAlign: "center",
                                color: "#fff",

                                marginBottom: "45px",
                                alignSelf: "center",
                                alignContent: "center",

                                width: "80%",
                            }}
                        />

                        <div style={{ marginTop: 12, display: "flex", gap: 8, justifyContent: "center", alignItems: "center", width: "100%" }}>
                            <div style={{ display: "flex", gap: 8, justifyContent: "center", alignItems: "center" }}>
                                {awaitingConfirmSend ? (
                                    <>
                                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                                            <button onClick={async () => {
                                                setAwaitingConfirmSend(false);
                                                try {
                                                    setSendStatus("sending");

                                                    // Build the exact messagesWithLinks object (same logic used in sendingemails)
                                                    const derivedSubject = makeEmailSubject();
                                                    const source = Array.isArray(thesearethemessages) ? thesearethemessages : [];
                                                    const messagesWithLinks = source.map((m) => {
                                                        const copy = Object.assign({}, m);
                                                        if (!copy.subject) copy.subject = derivedSubject;
                                                        // ✅ FIXED: Don't append link to body - keep body clean
                                                        copy.body = (copy.body || "").toString();
                                                        return copy;
                                                    });

                                                    const userRef = doc(firebase, "users", id);
                                                    try {
                                                        await updateDoc(userRef, { thesearethemessages: messagesWithLinks });
                                                    } catch (updateErr) {
                                                        if (updateErr?.code === "not-found" || /no document/i.test(updateErr.message || "")) {
                                                            await setDoc(userRef, { thesearethemessages: messagesWithLinks }, { merge: true });
                                                        } else {
                                                            throw updateErr;
                                                        }
                                                    }
                                                    console.log("Saved exact messagesWithLinks to Firestore for user:", id);

                                                    // Call sendingemails and pass the exact array so backend and Firestore match
                                                    await sendingemails(undefined, messagesWithLinks);

                                                } catch (err) {
                                                    console.error("Error sending after confirmation:", err);
                                                    setSendStatus("error");
                                                    alert("Failed to send messages. See console for details.");
                                                }
                                            }}
                                                disabled={sendStatus === "sending"}
                                                style={{ padding: "8px 16px", fontSize: 16, cursor: sendStatus === "sending" ? "default" : "pointer" }}
                                            >
                                                {sendStatus === "sending" ? "Sending…" : "Confirm Send"}
                                            </button>

                                            <button
                                                onClick={() => {
                                                    setAwaitingConfirmSend(false);
                                                    // prepared messages remain visible for review/edit
                                                }}
                                                style={{ padding: "8px 12px", fontSize: 14, background: "#444", color: "#fff", border: "none", borderRadius: 4 }}
                                            >
                                                Cancel
                                            </button>
                                            {towhom == "Parents" ? <>
                                                <button
                                                onClick={async () => {
                                                    const nextLevel = locallinklevel < 2 ? locallinklevel + 1 : 0;
                                                    console.log(`🎯 Button clicked: locallinklevel ${locallinklevel} → ${nextLevel}`);

                                                    try {
                                                        const host = "https://fastclasspass.web.app";
                                                        const out = {};

                                                        const parseStringStudent = (str) => {
                                                            if (!str || typeof str !== "string") return {};
                                                            const t = str.trim();
                                                            if (t.startsWith("{") || t.startsWith("[")) {
                                                                try { return JSON.parse(str); } catch (e) { /* fallthrough */ }
                                                            }
                                                            const obj = {};
                                                            const parts = str.split(/,(?=\s*[A-Za-z0-9_])/);
                                                            for (const p of parts) {
                                                                const idx = p.indexOf(":");
                                                                if (idx === -1) continue;
                                                                const key = p.slice(0, idx).trim().replace(/(^['"]|['"]$)/g, "");
                                                                let val = p.slice(idx + 1).trim().replace(/^[\(\[\{]\s*/, '').replace(/\s*[\)\]\}]$/, '').trim();
                                                                if (val.startsWith("[") || val.includes(",'") || val.includes('","')) {
                                                                    obj[key] = val.replace(/^\[|\]$/g, '').split(/[,;]+/).map(x => x.replace(/['"\s]/g, '').trim()).filter(Boolean);
                                                                } else {
                                                                    obj[key] = val.replace(/^['"]|['"]$/g, '').trim();
                                                                }
                                                            }
                                                            return obj;
                                                        };

                                                        for (const raw of students) {
                                                            const s = (typeof raw === "string") ? parseStringStudent(raw) : (raw || {});
                                                            const studentId = (s.firebasestudentid || s.studentId || s.studentid || s.id || "").toString();
                                                            const classId = (localclassid || "").toString();
                                                            const teacherId = (localteacherid || id || "").toString();
                                                            const lang = (s.parentlanguagecode || s.parentLanguageCode || "en").toString().trim() || "en";

                                                            if (!studentId) continue;

                                                            if (nextLevel === 1 && classId && teacherId) {
                                                                out[studentId] = `${host}/only2studentid/${encodeURIComponent(studentId)}/${encodeURIComponent(classId)}/id/${encodeURIComponent(teacherId)}/language/${encodeURIComponent(lang)}`;
                                                            } else if (nextLevel === 2 && classId && teacherId) {
                                                                out[studentId] = `${host}/studentid/${encodeURIComponent(studentId)}/${encodeURIComponent(classId)}/id/${encodeURIComponent(teacherId)}/language/${encodeURIComponent(lang)}`;
                                                            } else {
                                                                out[studentId] = "";
                                                            }
                                                        }

                                                        setLocallinklevel(nextLevel);
                                                        setStudentLinks(out);

                                                        // Rebuild PARENTS ONLY
                                                        const parentMsgs = await sendingemails3(students);
                                                        setThesearethemessages2(Array.isArray(parentMsgs) ? parentMsgs : []);
                                                        setShowPreparedMessages(true);
                                                        setAwaitingConfirmSend(true);
                                                    } catch (e) {
                                                        console.error("failed to build parent preview after link toggle", e);
                                                    }
                                                }}
                                                style={{ padding: "8px 12px", fontSize: 14, background: "#0a84ff", color: "#fff", border: "none", borderRadius: 4 }}
                                            >
                                                {locallinklevel && locallinklevel > 0 ? "Change Link" : "Add Link"}
                                            </button></> : null}

                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                    <input
                                                        value={String(valueToSendOrNotSentEmails ?? "0")}
                                                        onChange={(event) => {
                                                            const digitsOnly = String(event.target.value ?? "")
                                                                .replace(/\D/g, "")
                                                                .slice(0, 3);

                                                            setValueToSendOrNotSentEmails(
                                                                digitsOnly.length > 0 ? digitsOnly : ""
                                                            );
                                                        }}
                                                        onBlur={commitValueToSendOrNotSentEmails}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter") {
                                                                commitValueToSendOrNotSentEmails();
                                                            }
                                                        }}
                                                        inputMode="numeric"
                                                        maxLength={3}
                                                        style={{
                                                            width: 56,
                                                            minHeight: 38,
                                                            border: "1px solid #e43522",
                                                            borderRadius: 8,
                                                            background: "#111",
                                                            color: "#fff",
                                                            fontSize: 18,
                                                            fontWeight: 700,
                                                            textAlign: "center",
                                                            padding: "6px 8px",
                                                        }}
                                                    />
                                                    <span style={{ color: "#fff", fontSize: 16, fontWeight: 700 }}>to</span>
                                                    <input
                                                        value={String(valueToSendOrNotSentEmailsHigh ?? "100")}
                                                        onChange={(event) => {
                                                            const digitsOnly = String(event.target.value ?? "")
                                                                .replace(/\D/g, "")
                                                                .slice(0, 3);

                                                            setValueToSendOrNotSentEmailsHigh(
                                                                digitsOnly.length > 0 ? digitsOnly : ""
                                                            );
                                                        }}
                                                        onBlur={commitValueToSendOrNotSentEmailsHigh}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter") {
                                                                commitValueToSendOrNotSentEmailsHigh();
                                                            }
                                                        }}
                                                        inputMode="numeric"
                                                        maxLength={3}
                                                        style={{
                                                            width: 56,
                                                            minHeight: 38,
                                                            border: "1px solid #e43522",
                                                            borderRadius: 8,
                                                            background: "#111",
                                                            color: "#fff",
                                                            fontSize: 18,
                                                            fontWeight: 700,
                                                            textAlign: "center",
                                                            padding: "6px 8px",
                                                        }}
                                                    />
                                            </div>

                                            <button
                                                onClick={applyScoreFilterToParentPreview}
                                                style={{ padding: "8px 12px", fontSize: 14, background: "#2f6fed", color: "#fff", border: "none", borderRadius: 4 }}
                                            >
                                                Apply filter
                                            </button>

                                        </div>
                                    </>
                                ) : (
                                    (towhom != "" && localdescription != "") ? (
                                        <button
                                            onClick={() => {
                                                if (towhom === "Parents") {
                                                    startPrepareAndSend();
                                                } else if (towhom === "Students") {
                                                    startPrepareAndSendToStudents();
                                                } else {
                                                    startPrepareAndSendToBoth();
                                                }
                                            }}
                                            disabled={sendStatus === "sending"}
                                            style={{ padding: "8px 16px", fontSize: 16, cursor: sendStatus === "sending" ? "default" : "pointer" }}
                                        >
                                            {sendStatus === "sending" ? "Sending…" : `Send to ${towhom}`}
                                        </button>
                                    ) : localdescription != "" ? (
                                        <div style={{ display: "flex", gap: 8 }}>
                                            <button
                                                onClick={() => { setTowhom("Parents"); startPrepareAndSend(); }}
                                                disabled={sendStatus === "sending"}
                                                style={{ padding: "8px 16px", fontSize: 16, cursor: sendStatus === "sending" ? "default" : "pointer" }}
                                            >
                                                Send to Parents
                                            </button>
                                            <button
                                                onClick={() => { setTowhom("Students"); startPrepareAndSendToStudents(); }}
                                                disabled={sendStatus === "sending"}
                                                style={{ padding: "8px 16px", fontSize: 16, cursor: sendStatus === "sending" ? "default" : "pointer" }}
                                            >
                                                Send to Students
                                            </button>
                                            <button
                                                onClick={() => { setTowhom("Both"); startPrepareAndSendToBoth(); }}
                                                disabled={sendStatus === "sending"}
                                                style={{ padding: "8px 16px", fontSize: 16, cursor: sendStatus === "sending" ? "default" : "pointer" }}
                                            >
                                                Send to Both
                                            </button>
                                        </div>) : (

                                        Array.isArray(notifications) && notifications.length > 0 ? (
                                            <button
                                                onClick={handleLoadNotifications}
                                                style={{
                                                    padding: "8px 16px",
                                                    fontSize: 16,
                                                    cursor: "pointer",
                                                    background: "#0a84ff",
                                                    color: "#fff",
                                                    border: "none",
                                                    borderRadius: 6,
                                                    marginRight: "auto",
                                                    marginLeft: "auto"
                                                }}
                                            >
                                                Load Notifications ({notifications.length})
                                            </button>
                                        ) : null

                                    )
                                )}
                            </div>
                        </div>

                        {/* two line breaks between buttons and preview, and preview centered */}
                        {thesearethemessages?.length > 0 && (
                            <div style={{ width: "90%", maxWidth: 800, color: "#fff", margin: "0 auto", textAlign: "center" }}>
                                <br />
                                <br />
                                <h1 style={{ fontSize: 18, margin: "6px 0" }}>
                                    Messages to be sent to {previewSelectedSetCount}  {towhom === "Parents" ? "Parents" : towhom === "Students" ? "Students" : "Both Parent and Students"} 
                                </h1>
                                <div>
                                    {thesearethemessages.map((m, idx) => {
                                        const rawBody = (m?.body || "").toString();


                                        // --- PATCH: Show link only for parent messages (has .parentemail and no .email) ---
                                        const isParentMessage = !!m.parentemail && !m.email;
                                        let linkForMessage = null;
                                        let linkSource = "none";
                                        // 1. If studentLinks has a link for this student, use it

                                        // Only use footer links for built-in FastClassPass parent links.
                                        if (isParentMessage && m?.studentId && studentLinks && studentLinks[m.studentId]) {
                                            linkForMessage = studentLinks[m.studentId];
                                            linkSource = "studentLinks";
                                        }
                                        // Log which link is being used for this message
                                        console.log(`[Preview] idx=${idx} to=${m.to} isParentMessage=${isParentMessage} studentId=${m?.studentId} linkForMessage=`, linkForMessage, "source=", linkSource, "rawBody=", rawBody);

                                        const subjectForDisplay = m?.subject || makeEmailSubject();

                                        // Remove any fastclasspass.web.app links from body for display
                                        const bodyWithoutUrl = rawBody.replace(new RegExp(`https?:\/\/fastclasspass\\.web\\.app[^\\s\\n]*`, "g"), "").trim();

                                        let linkLabel = "";
                                        if (linkForMessage) {
                                            if (linkForMessage.includes("/studentid/")) {
                                                linkLabel = "Link Containing Grades Info.";
                                            } else if (linkForMessage.includes("/only2studentid/")) {
                                                linkLabel = "Link Not containing Grades Info.";
                                            } else {
                                                linkLabel = locallinklevel === 2 ? "Link Containing Grades Info." : (locallinklevel === 1 ? "Link Not containing Grades Info." : "Open Link");
                                            }
                                        }

                                        return (
                                            <div key={idx} style={{ padding: 8 }}>
                                                {/* Delete button row */}
                                                <div style={{ textAlign: "center", marginBottom: 8 }}>
                                                    <p
                                                        className="section5922ab"
                                                        onClick={() => removeMessage(idx)}
                                                        data-tooltip-id="my-tooltip-24"
                                                        onMouseEnter={() => setIsOpen24(true)}
                                                        onMouseLeave={() => setIsOpen24(false)}
                                                        style={{
                                                            display: "inline-block",
                                                            cursor: "pointer",
                                                            fontSize: "20px",
                                                            margin: 0,
                                                            padding: "4px 8px"
                                                        }}
                                                    >
                                                        ❌
                                                    </p>
                                                </div>

                                                <div style={{ fontWeight: 600 }}>{m.to}</div>
                                                <div style={{ fontStyle: "italic", color: "#ddd", marginTop: 4 }}>{subjectForDisplay}</div>
                                                <div style={{ whiteSpace: "pre-wrap", marginTop: 6 }}>
                                                    {renderBodyWithLinks(bodyWithoutUrl)}
                                                    <br />
                                                    <br />
                                                    {linkForMessage && (
                                                        <a
                                                            href={decodeURIComponent(linkForMessage)}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            onClick={(e) => {
                                                                console.log("Anchor clicked! Event:", e);
                                                                console.log("href:", e.currentTarget.href);
                                                                console.log("target:", e.currentTarget.target);
                                                                // Don't prevent default - let browser handle it
                                                            }}
                                                            style={{
                                                                color: "#0a84ff",
                                                                textDecoration: "underline",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            {linkLabel}
                                                        </a>
                                                    )}
                                                </div>
                                                <br></br><br></br><br></br>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        <br />
                        <br />
                    </div>
                </>
            </div>


            {isLinkModalOpen && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                    onClick={() => setIsLinkModalOpen(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: "#222",
                            color: "#fff",
                            padding: 20,
                            borderRadius: 8,
                            width: "min(720px, 90%)",
                        }}
                    >
                        <h3 style={{ marginTop: 0 }}>Add Hyperlink</h3>
                        <div style={{ marginBottom: 10 }}>
                            <label style={{ display: "block", marginBottom: 6 }}>Link text</label>
                            <input
                                value={linkFrontText}
                                onChange={(e) => setLinkFrontText(e.target.value)}
                                placeholder="What should users see (e.g. 'More info')"
                                style={{ width: "100%", padding: 8, borderRadius: 4 }}
                            />
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <label style={{ display: "block", marginBottom: 6 }}>URL</label>
                            <input
                                value={linkHref}
                                onChange={(e) => setLinkHref(e.target.value)}
                                placeholder="https://example.com"
                                style={{ width: "100%", padding: 8, borderRadius: 4 }}
                            />
                        </div>
                        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                            <button
                                onClick={() => setIsLinkModalOpen(false)}
                                style={{ padding: "8px 12px", background: "#444", color: "#fff", border: "none", borderRadius: 4 }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={saveLinkToDescription}
                                style={{ padding: "8px 12px", background: "#0a84ff", color: "#fff", border: "none", borderRadius: 4 }}
                            >
                                Insert Link
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {renderEmailReportModal()}
            {renderNotificationsModal()}
            <ReactTooltip
                id="my-tooltip-8"
                place="bottom"
                content="Add 'Student Name' To End Of Current Text"
                isOpen={isOpen8}
                style={{ color: "orange", fontSize: "25px" }}
            />


            <ReactTooltip
                id="my-tooltip-9"
                place="bottom"
                content="Add 'Selected Assignment Name' to End Of Current Text"
                isOpen={isOpen9}
                style={{ color: "orange", fontSize: "25px" }}
            />

            <ReactTooltip
                id="my-tooltip-10"
                place="bottom"
                content="Add 'Student Score for the Selected Assignment' To End Of Current Text"
                isOpen={isOpen10}
                style={{ color: "orange", fontSize: "25px" }}
            />
            <ReactTooltip
                id="my-tooltip-11"
                place="bottom"
                content={"Attachments for the selected assignment\nof the particular student will be included\nin the emails sent to parents. Click to toggle."}
                isOpen={isOpen11}
                style={{ color: "orange", fontSize: "25px", whiteSpace: "pre-line" }}
            />
            <ReactTooltip
                id="my-tooltip-12"
                place="bottom"
                content={"Attachments for the selected assignment\n of the particular student will NOT be included\n in the emails sent to parents. Click to toggle."}
                isOpen={isOpen12}
                style={{ color: "orange", fontSize: "25px", whiteSpace: "pre-line" }}
            />
            <ReactTooltip
                id="my-tooltip-17"
                place="bottom"
                content="Add Link To End Of Current Text"
                isOpen={isOpen17}
                style={{ color: "orange", fontSize: "25px" }}
            />

                 <ReactTooltip
                id="my-tooltip-13"
                place="bottom"
                content={`Current attachment filter: ${selectedAttachmentUi.label}`}
                isOpen={isOpen13}
                style={{ color: "orange", fontSize: "25px" }}
            />
        </>
    );

};

export default SignIn;